import type { Messages } from './messages.fr';

/** Catalogue DE — doit satisfaire `Messages` (parité de clés garantie par le type). */
export const de: Messages = {
  nav: {
    home: 'Startseite',
    gallery: 'Galerie',
    folders: 'Ordner',
    tags: 'Tags',
    aiReview: 'Zu prüfen (KI)',
    aiReviewCount_one: '{count} Foto zu prüfen (KI)',
    aiReviewCount_other: '{count} Fotos zu prüfen (KI)',
  },
  breadcrumb: {
    label: 'Brotkrümelpfad',
    home: 'Startseite',
    exifTool: 'EXIF-Bereinigung',
    exifPublishTool: 'EXIF-Tags schreiben',
    dedupTool: 'Duplikatsuche',
    taxonomy: 'Taxonomie',
    aiTrace: 'KI-Protokoll',
    admin: 'Admin',
    superadmin: 'Superadmin',
    adminGeneral: 'Allgemein',
    adminUsers: 'Konten',
    sessionLinks: 'Zugangslinks',
    apiKeys: 'API-Schlüssel',
    adminGrants: 'Zugriff',
    adminLogs: 'Protokolle',
    adminFileErrors: 'Dateifehler',
    adminMissingFiles: 'Fehlende Dateien',
    adminTrash: 'Papierkorb',
    adminReset: 'Wartung',
    settings: 'Einstellungen',
    settingsAccount: 'Mein Konto',
    settingsAppearance: 'Darstellung',
    llmConfig: 'LLM-Konfiguration',
  },
  menu: {
    openLanguage: 'Sprache wählen',
    openTheme: 'Design wählen',
  },
  theme: {
    light: 'Hell',
    dark: 'Dunkel',
    system: 'System',
  },
  lang: {
    fr: 'Französisch',
    de: 'Deutsch',
    en: 'Englisch',
  },
  pwa: {
    updateAvailable: 'Neue Version verfügbar',
    reload: 'Neu laden',
    reloading: 'Wird neu geladen…',
    install: 'App installieren',
    iosTitle: 'App installieren',
    iosIntro: 'Fügen Sie {name} auf iPhone oder iPad zum Startbildschirm hinzu:',
    iosStep1: 'Tippen Sie in Safari auf die Schaltfläche „Teilen“.',
    iosStep2: 'Wählen Sie „Zum Home-Bildschirm“.',
    iosClose: 'Schließen',
  },
  gallery: {
    countLabel: 'Medien',
    loading: 'Medien werden geladen…',
    empty: 'Keine Medien',
    emptyHint: 'Starten Sie einen Scan, um die Bibliothek zu indexieren.',
    errorTitle: 'Medien konnten nicht geladen werden',
    retry: 'Erneut versuchen',
    retryNow: 'Jetzt erneut versuchen',
    errorRateLimitedTitle: 'Zu viele Anfragen',
    errorRateLimitedRetryIn: 'Automatischer neuer Versuch in {seconds} s…',
    errorRateLimitedAuto: 'Automatischer neuer Versuch läuft.',
    errorRateLimitedExhausted:
      'Der Server drosselt weiterhin. Bitte in einem Moment erneut versuchen.',
    errorNetworkTitle: 'Verbindung zum Server nicht möglich',
    errorServerTitle: 'Serverfehler — bitte erneut versuchen',
    pageErrorTitle: 'Einige Fotos konnten nicht geladen werden',
    pageErrorRateLimited: 'Zu viele Anfragen: Einige Fotos konnten nicht geladen werden.',
    pageErrorNetwork: 'Verbindung verloren: Einige Fotos konnten nicht geladen werden.',
    pageErrorServer: 'Serverfehler: Einige Fotos konnten nicht geladen werden.',
    pageErrorAutoRetry: 'Automatischer Wiederholungsversuch läuft…',
    noLibrary: 'Keine Bibliothek ausgewählt',
    noLibraryHint: 'Setzen Sie VITE_LIBRARY_ID, um eine Bibliothek anzuzeigen.',
    thumbnailAlt: 'Miniaturansicht von {name}',
    tabsLabel: 'Galerie-Bereiche',
    activeExifField: 'EXIF-Filter — Feld {field}',
    activePublishInSync: 'EXIF-Filter — synchrone Medien',
    activePublishOutOfSync: 'EXIF-Filter — zu veröffentlichende Medien',
    clearFilter: 'Löschen',
    clearExifFilter: 'EXIF-Filter löschen',
    // Ansicht „Zu prüfen (KI)“: auffälliger Button, der den Tagger für die gesamte gefilterte Menge öffnet.
    reviewPending_one: 'Dieses Foto prüfen',
    reviewPending_other: 'Diese {count} Fotos prüfen',
    reviewPreparing: 'Wird vorbereitet…',
    reviewEmpty: 'Keine Fotos zu prüfen.',
    reviewError: 'Prüfung konnte nicht vorbereitet werden. Bitte erneut versuchen.',
  },
  folders: {
    title: 'Ordner',
    empty: 'Keine Ordner',
    root: 'Wurzel',
    countLabel_one: '{count} Medium',
    countLabel_other: '{count} Medien',
    open: 'Ordner {name} öffnen',
    filterLabel: 'Ordner filtern',
    filterPlaceholder: 'Ordner filtern…',
    sortBy: 'Ordner sortieren nach',
    sortName: 'Name',
    sortDate: 'Datum',
    sortOrder: 'Reihenfolge',
    sortAsc: 'Aufsteigend',
    sortDesc: 'Absteigend',
    subfolders: 'Unterordner',
    emptyBadge: 'Leer',
    subfoldersOnly: 'Nur Unterordner',
    notIndexed: 'Nicht im Index',
    photosHere: 'Fotos',
    breadcrumbLabel: 'Ordnerpfad',
  },
  tagsTab: {
    title: 'Tags',
    empty: 'Noch keine Tags',
    emptyHint: 'Tags erscheinen nach dem Taggen.',
    select: 'Nach Tag {label} filtern',
    countLabel_one: '{count} Medium',
    countLabel_other: '{count} Medien',
  },
  sort: {
    label: 'Sortieren & filtern',
    open: 'Sortieren & filtern',
    sortBy: 'Sortieren nach',
    random: 'Zufällig',
    takenAt: 'Aufnahmedatum',
    filename: 'Dateiname',
    sizeBytes: 'Größe',
    createdAt: 'Hinzugefügt am',
    viewCount: 'Aufrufe',
    rating: 'Bewertung',
    order: 'Reihenfolge',
    asc: 'Aufsteigend',
    desc: 'Absteigend',
    reshuffle: 'Neu mischen',
    reshuffling: 'Wird gemischt…',
    reshuffleError: 'Neu mischen fehlgeschlagen. Bitte erneut versuchen.',
    type: 'Typ',
    typeAll: 'Alle',
    typeImage: 'Bilder',
    typeAnimatedImage: 'Animierte Bilder',
    typeVideo: 'Videos',
    typeVideoWithSound: 'Videos mit Ton',
    filterSection: 'Filter',
    untagged: 'Nicht getaggt',
    aiReview: 'Zu prüfen (KI)',
  },
  density: {
    open: 'Dichte wählen',
    S: 'Kompakt',
    M: 'Standard',
    L: 'Komfortabel',
  },
  tools: {
    open: 'Werkzeugmenü öffnen',
    openOverflow: 'Mehr',
    upload: 'Dateien hochladen',
    scan: 'Scan starten',
    scanning: 'Scan läuft…',
    scanFailed: 'Scan fehlgeschlagen',
    scanAlreadyRunning:
      'Eine Analyse läuft bereits oder steht in der Warteschlange. Bitte abwarten.',
    tagAiConfirm:
      'Für die gesamte Bibliothek KI-Tags vorschlagen? Die Vorschläge müssen anschließend bestätigt werden.',
    tagAiConfirmSelection:
      'Für die {count} ausgewählten Medien KI-Tags vorschlagen? Die Vorschläge müssen anschließend bestätigt werden.',
    tagAiConfirmTitle: 'Mit KI taggen',
    tagAiConfirmAction: 'Tagging starten',
    tagAiCancel: 'Abbrechen',
    tagAiQueuing: 'Wird gestartet…',
    tagAiNoProvider:
      'Kein LLM-Anbieter konfiguriert. Ein Superadmin kann einen unter Superadmin → LLM-Konfiguration einrichten.',
    tagAiDisabled: 'Die KI-Funktionen wurden vom Administrator deaktiviert.',
    tagAiFailed: 'KI-Tagging konnte nicht gestartet werden',
    dedup: 'Duplikatsuche',
    exif: 'EXIF-Bereinigung',
    exifPublish: 'Tags in EXIF schreiben',
    fixExtensions: 'Dateiendungen korrigieren',
    cleanEmptyFolders: 'Leere Ordner aufräumen',
    taxonomy: 'Tags verwalten',
  },
  select: {
    toggle: '{name} auswählen',
    // Umschalter des AUSWAHLMODUS (Werkzeugleiste): betreten / verlassen. Verlassen leert die Auswahl.
    enterMode: 'Auswählen',
    exitMode: 'Fertig',
    selectedCount: '{count} ausgewählt',
    // Auslöser des Menüs mit den Auswahlaktionen (Verschieben/Bewerten/…/Löschen).
    actions: 'Aktionen…',
    clear: 'Auswahl leeren',
    selectAll: 'Alle auswählen ({count})',
    deselectAll: 'Auswahl aufheben',
    selecting: 'Wird ausgewählt…',
    selectAllError: 'Auswahl aller Medien fehlgeschlagen. Bitte erneut versuchen.',
    selectAllForbidden: 'Sie haben keine Berechtigung, diese Medien auszuwählen.',
    download: 'Auswahl herunterladen',
    downloading: 'Archiv wird vorbereitet…',
    downloadError: 'Auswahl konnte nicht heruntergeladen werden. Bitte erneut versuchen.',
    downloadForbidden: 'Sie haben keine Berechtigung, diese Medien herunterzuladen.',
    tagSelection: 'Tags prüfen / bestätigen',
    slideshow: 'Diashow',
  },
  badge: {
    missing: 'Auf Datenträger fehlend',
    video: 'Video',
  },
  viewer: {
    title: 'Bildbetrachter',
    open: '{name} im Betrachter öffnen',
    close: 'Betrachter schließen',
    previous: 'Vorheriges Medium',
    next: 'Nächstes Medium',
    download: 'Original herunterladen',
    counter: '{index} / {total}',
    showInfo: 'Dateiname anzeigen',
    hideInfo: 'Dateiname ausblenden',
    showDetail: 'Details anzeigen',
    hideDetail: 'Details ausblenden',
    loading: 'Medium wird geladen…',
    error: 'Medium konnte nicht geladen werden',
    errorNotFound: 'Dieses Medium existiert nicht mehr',
    errorNotFoundHint: 'Es wurde möglicherweise gelöscht oder verschoben.',
    errorForbidden: 'Zugriff auf dieses Medium verweigert',
    errorForbiddenHint: 'Es gehört nicht zu dem, was für Sie freigegeben wurde.',
    errorNetwork: 'Keine Verbindung zum Server',
    errorNetworkHint: 'Prüfen Sie Ihre Verbindung und laden Sie die Seite neu.',
    errorUnknownHint: 'Laden Sie die Seite neu oder versuchen Sie es später erneut.',
    retry: 'Erneut versuchen',
    play: 'Diashow starten',
    pause: 'Diashow pausieren',
    loopOn: 'Endlosschleife aktivieren',
    loopOff: 'Endlosschleife deaktivieren',
    speed: 'Diashow-Geschwindigkeit',
    speedValue: '{seconds} s',
    cap: 'Maximale Dauer eines langen Mediums',
    capValue: 'max. {seconds} s',
    capUnlimited: 'ohne Limit',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    zoomReset: 'Standardgröße',
    zoomLevel: 'Zoom: {percent} %',
    videoUnsupported: 'Ihr Browser kann dieses Video nicht abspielen.',
    openRating: 'Foto bewerten',
    closeRating: 'Bewertung schließen',
    openComments: 'Foto kommentieren',
    closeComments: 'Kommentare schließen',
    // SCHREIB-Aktionen der oberen Leiste (die Drehungen nutzen `rotate.cw/ccw`).
    trash: 'Dieses Foto in den Papierkorb legen',
    // Rückgängig-Banner, direkt nach dem Verschieben in den Papierkorb.
    trashed: '{name} im Papierkorb',
    undo: 'Rückgängig',
    // Mobiles Überlaufmenü der vier Anzeige-Schalter: die Einträge benennen, WAS
    // angezeigt wird (den Zustand trägt das Häkchen).
    displayOptions: 'Anzeigeoptionen',
    optionRating: 'Bewertung',
    optionComments: 'Kommentare',
    optionCaption: 'Dateiname',
    optionDetail: 'Details',
  },
  publicShare: {
    count_one: '{count} Medium',
    count_other: '{count} Medien',
    loading: 'Freigabe wird geladen…',
    empty: 'Diese Freigabe enthält keine Medien.',
    openMedia: 'Medium {n} öffnen',
    viewerLabel: 'Medium {n} von {total}',
    position: '{n} / {total}',
    previous: 'Vorheriges Medium',
    next: 'Nächstes Medium',
    download: 'Originaldatei herunterladen',
    close: 'Schliessen',
    goneTitle: 'Dieser Link ist nicht mehr gültig',
    goneBody:
      'Die Freigabe ist möglicherweise abgelaufen oder wurde zurückgezogen. Bitten Sie um einen neuen Link.',
    errorTitle: 'Freigabe nicht verfügbar',
    errorBody: 'Die Freigabe konnte nicht geladen werden. Prüfen Sie Ihre Verbindung.',
    retry: 'Erneut versuchen',
  },
  share: {
    create: {
      title: 'Öffentlichen Link erstellen',
      intro: 'Dieser Link ist ohne Konto abrufbar — für alle, die ihn erhalten.',
      titleLabel: 'Titel des Links',
      scopeLabel: 'Inhalt',
      scopeRoot: 'Die gesamte für Sie sichtbare Bibliothek',
      scopeFolder: 'Ordner {folder} und seine Unterordner',
      scopeSelection: '{count} ausgewählte Medien',
      expiryLabel: 'Läuft ab',
      expiry: { d7: '7 Tage', d30: '30 Tage', y1: '1 Jahr', never: 'Nie' },
      lightweight: 'Verkleinerte Kopien teilen',
      lightweightHint:
        'WebP, höchstens 2560 px, Metadaten entfernt. Kleinere Fotos behalten ihre Grösse.',
      warnOriginals:
        'Die Originaldateien werden unverändert übertragen, samt Metadaten — auch dem Aufnahmeort. Videos werden immer als Originaldatei übertragen.',
      warnVideosOnly:
        'Fotos werden als Kopien ohne Metadaten übertragen. Videos werden immer als Originaldatei übertragen.',
      cancel: 'Abbrechen',
      submit: 'Link erstellen',
      submitting: 'Wird erstellt…',
      forbidden: 'Dieser Inhalt geht über das hinaus, was Sie sehen dürfen.',
      failed: 'Der Link konnte nicht erstellt werden.',
      doneTitle: 'Link erstellt',
      doneIntro: 'Kopieren Sie ihn jetzt und senden Sie ihn weiter.',
      onceOnly: 'Dieser Link wird nur einmal angezeigt und lässt sich danach nicht wiederfinden.',
      copy: 'Kopieren',
      done: 'Fertig',
    },
    list: {
      loading: 'Freigaben werden geladen…',
      empty: 'Noch keine öffentlichen Links.',
      failed: 'Die Freigaben konnten nicht geladen werden.',
      retry: 'Erneut versuchen',
      mediaCount: '{count} Medien',
      viewCount: '{count} Aufrufe',
      noExpiry: 'ohne Ablauf',
      expiresOn: 'läuft am {date} ab',
      revoke: 'Widerrufen',
      status: { live: 'Aktiv', expired: 'Abgelaufen', revoked: 'Widerrufen' },
    },
    mineTitle: 'Meine Freigaben',
    mineIntro: 'Die öffentlichen Links, die Sie erstellt haben.',
    adminTitle: 'Freigaben',
    adminIntro: 'Alle öffentlichen Links der Bibliothek, unabhängig vom Urheber.',
    short: 'Teilen',
    photo: 'Dieses Foto teilen',
    view: 'Diese Ansicht teilen',
    copied: 'Link kopiert',
    linkLabel: 'Zu kopierender Link',
    close: 'Schließen',
  },
  rating: {
    label: 'Bewertung',
    star: '{n}/5 bewerten',
    clear: 'Bewertung entfernen',
    error: 'Bewertung konnte nicht gespeichert werden',
    errorReadonly: 'Nur-Lese-Zugriff: Bewertung nicht änderbar',
  },
  comments: {
    bodyLabel: 'Kommentar',
    bodyPlaceholder: 'Kommentar schreiben…',
    add: 'Hinzufügen',
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    cancel: 'Abbrechen',
    edit: 'Kommentar bearbeiten',
    delete: 'Kommentar löschen',
    confirmTitle: 'Kommentar löschen',
    confirmDelete: 'Diesen Kommentar löschen?',
    confirmAction: 'Löschen',
    deleting: 'Wird gelöscht…',
    edited: 'bearbeitet',
    empty: 'Keine Kommentare',
    error: 'Kommentar konnte nicht gespeichert werden',
    errorReadonly: 'Nur-Lese-Zugriff: Kommentar nicht änderbar',
  },
  info: {
    title: 'Informationen',
    path: 'Pfad',
    mime: 'MIME-Typ',
    dimensions: 'Abmessungen',
    takenAt: 'Aufnahme',
    duration: 'Dauer',
    exif: 'EXIF-Metadaten',
    gps: 'GPS Breite/Länge',
    gpsOpen: 'In Google Maps öffnen',
    noExif: 'Keine EXIF-Daten',
    divergence: 'Abweichung Datenträger ↔ Datenbank',
    missing: 'Datei auf Datenträger fehlend',
    present: 'Auf Datenträger vorhanden',
    seenAt: 'Gesehen am',
  },
  exif: {
    title: 'EXIF-Bereinigung',
    close: 'EXIF-Bereinigung schließen',
    intro:
      'Vorhandene Metadaten erkennen, Fotos mit einem Feld durchsehen und dann ein bestimmtes Feld (oder alles) im Stapel über die gesamte Bibliothek oder einen Ordner löschen. Die Datenbank bleibt die Quelle der Wahrheit.',
    loading: 'Bibliothek wird analysiert…',
    errorTitle: 'EXIF-Analyse konnte nicht geladen werden',
    retry: 'Erneut versuchen',
    analysisTitle: 'Vorhandensein-Analyse',
    analysisTotal: '{total} vorhandene Medien analysiert',
    analysisHint:
      'Anzahl der Medien mit dem jeweiligen Feld. „Ansehen“ filtert die Galerie nach diesem Feld; „Dieses Feld löschen“ entfernt es im Stapel im gewählten Bereich.',
    groupCapture: 'Aufnahme',
    groupCamera: 'Kamera',
    groupRights: 'Rechte',
    groupKeywords: 'Schlüsselwörter',
    fieldPresence: '{present} / {total} vorhanden',
    filterByField: 'Galerie nach Feld {field} filtern',
    viewField: 'Ansehen',
    eraseField: 'Dieses Feld löschen',
    eraseFieldAction: 'Feld {field} bei den Medien im Bereich löschen',
    cleanedBadge: '✓ bereinigt',
    eraseOptionsTitle: 'Löschoptionen',
    eraseScopeAll: 'die gesamte Bibliothek',
    eraseScopeFolder: 'den Ordner {folder}',
    publishTitle: 'Tags veröffentlichen',
    publishHint:
      'Schreibt die in der Datenbank freigegebenen Tags (IPTC:Keywords + XMP dc:subject) nur in abweichende Dateien.',
    taggedAssets: 'Getaggte Medien',
    inSync: 'Synchron',
    outOfSync: 'Zu veröffentlichen',
    filterInSync: 'Galerie auf synchrone Medien filtern',
    filterOutOfSync: 'Galerie auf zu veröffentlichende Medien filtern',
    publish: 'Veröffentlichen',
    previewPublish: 'Veröffentlichung simulieren',
    publishToolTitle: 'Tags in EXIF schreiben',
    publishToolClose: 'Veröffentlichungswerkzeug schließen',
    publishToolIntro:
      'Schreibt die in der Datenbank freigegebenen Tags in die Metadaten der Dateien (IPTC:Keywords + XMP dc:subject). Nur abweichende Dateien werden neu geschrieben.',
    eraseTitle: 'Vollständiges Löschen (erweitert)',
    eraseHint:
      'Löscht ALLE eingebetteten Metadaten (inkl. GPS). Stapelaktion, ohne Sicherung unumkehrbar. Um ein Feld zu behalten, nutzen Sie oben „Dieses Feld löschen“.',
    eraseAllOptionsNote:
      'Die Optionen oben (Simulation, _original-Sicherung, Ordnerbereich) gelten AUCH für „Alles löschen“ — eine Simulation ändert nichts.',
    erase: 'Alles löschen',
    folderScope: 'Bereich (Ordner)',
    folderAll: 'Gesamte Bibliothek',
    keepOriginal: 'Original behalten (_original)',
    keepOriginalHint: 'Sichert die Originaldatei vor dem Schreiben daneben.',
    noBackupWarning:
      'Ohne Sicherung: Die Dateien werden direkt geändert, ohne Sicherungskopie (_original). Unumkehrbar.',
    dryRun: 'Simulation (Dry-Run)',
    dryRunHint: 'Simuliert, ohne Dateien zu ändern.',
    queuing: 'Wird eingereiht…',
    jobQueued: 'Job eingereiht (#{id})',
    jobFailed: 'Job konnte nicht eingereiht werden',
    errorWriteDisabled:
      'Schreiben in der Bibliothek deaktiviert: Löschen nicht möglich. Binden Sie /library serverseitig schreibbar ein.',
    eraseConfirmClose: 'Schließen',
    eraseConfirmWarning: 'Diese Aktion ist unumkehrbar.',
    eraseConfirmCancel: 'Abbrechen',
    eraseConfirmApply: 'Löschen',
    eraseConfirmApplying: 'Wird eingereiht…',
    eraseConfirmFieldTitle: 'Dieses EXIF-Feld löschen?',
    eraseConfirmFieldBody:
      'Das Feld {field} wird aus den Metadaten von {scope} gelöscht. Andere Felder bleiben erhalten.',
    eraseConfirmAllTitle: 'Alle Metadaten löschen?',
    eraseConfirmAllBody:
      'Alle Metadaten von {scope} werden gelöscht (außer den behaltenen Gruppen). GPS wird immer gelöscht.',
    autoResyncNote:
      'Das Löschen aktualisiert die betroffenen Fotos im Index automatisch — die gesamte Bibliothek muss nicht neu gescannt werden. Die Analyse wird am Jobende aktualisiert.',
    refreshAnalysis: 'Analyse aktualisieren',
    originals: {
      title: 'Sicherungsdateien _original',
      hint: 'ExifTool erstellt bei jedem Schreiben eine Datei „…_original“, wenn die Sicherungsoption aktiv ist. Suchen Sie sie, um zu wissen, wie viele es sind, und löschen Sie sie dann.',
      scan: 'Sicherungen suchen',
      found: '{count} Sicherungen gefunden (Gesamtgröße {size}).',
      none: 'Keine _original-Sicherungen gefunden.',
      error: '_original-Sicherungen konnten nicht gesucht werden.',
      delete: 'Sicherungen löschen',
      confirmTitle: '_original-Sicherungen löschen?',
      confirmBody:
        '{count} _original-Sicherungsdateien von {scope} ({size}) werden endgültig gelöscht. Die Originaldateien bleiben unangetastet.',
      confirmApply: 'Löschen',
    },
  },
  dedup: {
    title: 'Duplikatsuche',
    close: 'Duplikat-Werkzeug schließen',
    // Reiter (identische Kopien / ähnliche Bilder).
    tabsLabel: 'Duplikattyp',
    tabExact: 'Identische Kopien',
    tabSimilar: 'Ähnliche Bilder',
    similarTitle: 'Ähnliche Bilder',
    intro:
      'Gruppiert Beinahe-Duplikate (Neucodierungen, Größenänderungen, leichte Bearbeitungen) nach wahrnehmbarer Ähnlichkeit. Die Gruppierung kann irren: standardmäßig wird jedes Bild BEHALTEN; löschen Sie nur echte Duplikate.',
    loading: 'Gruppen werden geladen…',
    // Zusammenfassung (Kopf).
    summaryClusters_one: '{count} Gruppe',
    summaryClusters_other: '{count} Gruppen',
    summaryDuplicates_one: '{count} Duplikat-Kandidat',
    summaryDuplicates_other: '{count} Duplikat-Kandidaten',
    lastRunAt: 'Letzte Analyse: {when}',
    neverRun: 'Noch nie analysiert',
    // Analyse.
    thresholdLabel: 'Ähnlichkeitsschwelle',
    thresholdHint: 'Maximale Hamming-Distanz (0 = identisch, höher = großzügiger).',
    runAnalysis: 'Analyse starten',
    running: 'Wird eingereiht…',
    analysisQueued: 'Analyse eingereiht. Fortschritt in der Glocke verfolgen, dann aktualisieren.',
    refresh: 'Gruppen aktualisieren',
    // Gruppenmitglieder.
    resolution: '{width} × {height}',
    resolutionUnknown: 'Auflösung unbekannt',
    keeperSuggested: 'Vorgeschlagenes Original',
    openInViewer: '{name} im Betrachter öffnen',
    // Entscheidung pro Bild (Behalten / Löschen).
    decisionLabel: 'Entscheidung für {name}',
    decisionKeep: 'Behalten',
    decisionDelete: 'Löschen',
    lastKeptHint: 'Das letzte behaltene Bild der Gruppe kann nicht gelöscht werden.',
    // Anwenden.
    applyButton: 'Ausgewählte Duplikate löschen',
    applyNone: 'Keine Duplikate ausgewählt',
    selectedForDeletion_one: '{count} Datei zum Löschen',
    selectedForDeletion_other: '{count} Dateien zum Löschen',
    // Bestätigungsdialog.
    confirmTitle: 'Duplikate endgültig löschen?',
    confirmClose: 'Schließen',
    confirmWarning: 'Diese Aktion ist unwiderruflich.',
    confirmBody:
      '{count} Dateien werden von der Festplatte GELÖSCHT. Die gewählten Originale bleiben erhalten. Vignetten und Index werden beim nächsten Scan aktualisiert.',
    confirmCancel: 'Abbrechen',
    confirmApply_one: '{count} Datei löschen',
    confirmApply_other: '{count} Dateien löschen',
    applying: 'Wird eingereiht…',
    applyRunning: 'Löschung läuft…',
    applyQueued: 'Löschung eingereiht. Fortschritt in der Glocke verfolgen.',
    // Gruppe als „Fehltreffer“ verwerfen (keine Duplikate).
    notDuplicates: 'Das sind keine Duplikate',
    dismissing: 'Wird entfernt…',
    dismissError: 'Gruppe konnte nicht entfernt werden.',
    dismissForbidden: 'Schreibzugriff erforderlich, um eine Gruppe zu verwerfen.',
    // Fehler.
    errorTitle: 'Duplikatgruppen konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
    errorWriteDisabled:
      'Schreiben auf der Bibliothek ist deaktiviert: Löschen nicht möglich. Binden Sie /library serverseitig schreibbar ein.',
    errorApply: 'Löschung konnte nicht eingereiht werden.',
    errorRun: 'Analyse konnte nicht eingereiht werden.',
    // Leer.
    emptyNeverRun:
      'Es wurde noch keine Analyse ausgeführt. Starten Sie eine Analyse, um Duplikate zu erkennen.',
    emptyNoDuplicates: 'Keine Duplikate gefunden. Ihre Bibliothek ist sauber.',
    // Seitennavigation.
    prevPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    pageStatus: 'Gruppen {from}–{to} von {total}',
    // --- EXAKTE Kopien (eigener Abschnitt oben im Bildschirm) ---
    exact: {
      title: 'Exakte Kopien',
      intro:
        'Strikt identische Dateien (gleiche Pixel), die an mehreren Stellen auf der Festplatte vorhanden sind. Der Bestand stammt aus dem Scan. Wählen Sie pro Bild den zu behaltenden Pfad; die anderen Kopien werden gelöscht.',
      refresh: 'Aktualisieren',
      loading: 'Exakte Kopien werden geladen…',
      // Zusammenfassung.
      summaryGroups_one: '{count} Gruppe exakter Kopien',
      summaryGroups_other: '{count} Gruppen exakter Kopien',
      summaryRedundant_one: '{count} redundante Kopie',
      summaryRedundant_other: '{count} redundante Kopien',
      inventoryAt: 'Bestand aktuell zum {when}',
      neverScanned: 'Noch nie gescannt',
      // Gruppe.
      resolution: '{width} × {height}',
      resolutionUnknown: 'Auflösung unbekannt',
      kindImage: 'Bild',
      kindVideo: 'Video',
      noThumbnail: 'Keine Vorschau verfügbar',
      openInViewer: '{name} im Betrachter öffnen',
      canonical: 'Indexiert',
      identicalBytes: 'Byte-identisch',
      reencoded: 'Neucodierung (identische Pixel)',
      // Auswahl des zu behaltenden Pfads.
      chooseKeepLabel: 'Zu behaltenden Pfad wählen',
      willKeep: 'Wird behalten',
      willDelete: 'Wird gelöscht',
      // Grund für die Standardauswahl des Behaltenen (Symbol + Text, nie nur Farbe).
      keptLightest: 'kleinste',
      keptCanonical: 'indexierte Kopie',
      // Anwenden.
      applyButton: 'Redundante Kopien löschen',
      applyNone: 'Keine Kopie zum Löschen',
      selectedForDeletion_one: '{count} Kopie zum Löschen',
      selectedForDeletion_other: '{count} Kopien zum Löschen',
      pageScopeNote:
        'Die Löschung betrifft die Gruppen der angezeigten Seite. Bearbeiten Sie jede Seite, bevor Sie die Seite wechseln.',
      // Bestätigungsdialog.
      confirmTitle: 'Redundante Kopien endgültig löschen?',
      confirmClose: 'Schließen',
      confirmWarning: 'Diese Aktion ist unwiderruflich.',
      confirmBody:
        '{count} redundante Kopien werden von der Festplatte GELÖSCHT. Pro Bild bleibt ein Exemplar erhalten. Der Index wird beim nächsten Scan aktualisiert.',
      confirmCancel: 'Abbrechen',
      confirmApply_one: '{count} Kopie löschen',
      confirmApply_other: '{count} Kopien löschen',
      applying: 'Wird eingereiht…',
      applyRunning: 'Löschung läuft…',
      applyQueued: 'Löschung eingereiht. Fortschritt in der Glocke verfolgen.',
      // Fehler.
      errorTitle: 'Exakte Kopien konnten nicht geladen werden.',
      retry: 'Erneut versuchen',
      errorWriteDisabled:
        'Schreiben auf der Bibliothek ist deaktiviert: Löschen nicht möglich. Binden Sie /library serverseitig schreibbar ein.',
      errorApply: 'Löschung konnte nicht eingereiht werden.',
      // Leer.
      emptyNeverScanned:
        'Kein Scan durchgeführt — starten Sie einen Scan, um exakte Kopien zu erkennen.',
      emptyNoCopies: 'Keine exakten Kopien gefunden.',
      // Seitennavigation.
      prevPage: 'Vorherige Seite',
      nextPage: 'Nächste Seite',
      pageStatus: 'Gruppen {from}–{to} von {total}',
    },
  },
  passwordField: {
    show: 'Passwort anzeigen',
    hide: 'Passwort verbergen',
  },
  auth: {
    title: 'Anmeldung',
    emailPlaceholder: 'sie@beispiel.com',
    identifierLabel: 'Benutzername oder E-Mail',
    passwordLabel: 'Passwort',
    stayLoggedIn: 'Angemeldet bleiben',
    submit: 'Anmelden',
    submitting: 'Anmeldung…',
    invalidCredentials: 'Ungültige Anmeldedaten.',
    genericError: 'Anmeldung fehlgeschlagen. Bitte erneut versuchen.',
    checkingSession: 'Sitzung wird geprüft…',
    networkErrorTitle: 'Verbindung zum Server nicht möglich.',
    retry: 'Erneut versuchen',
    tooManyAccounts: 'Zu viele gleichzeitig angemeldete Konten.',
    cancelAddAccount: 'Abbrechen',
    account: 'Konto',
    signOut: 'Abmelden',
    roleSuperadmin: 'Superadmin',
    roleAdmin: 'Administrator',
    roleUser: 'Benutzer',
  },
  accountSwitcher: {
    title: 'Angemeldete Konten',
    addAccount: 'Konto hinzufügen',
    active: 'Aktives Konto',
    logoutAccount: 'Dieses Konto abmelden',
    confirmLogoutAll: 'Bestätigen: alle abmelden?',
    theme: 'Design',
    language: 'Sprache',
    myAccount: 'Mein Konto',
  },
  settings: {
    title: 'Einstellungen',
    close: 'Schließen',
    intro: 'Sehen Sie Ihr Konto ein und ändern Sie Ihr Passwort.',
    tabAccount: 'Konto',
    tabAppearance: 'Darstellung',
    defaultSortLabel: 'Standard-Sortierung der Startseite',
    defaultSortHint:
      'Reihenfolge auf der Startseite; anderswo (Ordner, Tags) bleibt die zuletzt gewählte Sortierung erhalten.',
    accountTitle: 'Konto',
    emailLabel: 'E-Mail-Adresse',
    nameLabel: 'Anzeigename',
    roleLabel: 'Rolle',
    changePasswordTitle: 'Passwort ändern',
    currentPasswordLabel: 'Aktuelles Passwort',
    passwordViaLink:
      'Sie sind über einen geteilten Zugangslink eingetreten: dieses Konto hat kein persönliches Passwort zum Ändern. Bitten Sie die Administration bei Bedarf um einen neuen Link.',
    newPasswordLabel: 'Neues Passwort',
    confirmPasswordLabel: 'Neues Passwort bestätigen',
    submit: 'Passwort ändern',
    submitting: 'Wird geändert…',
    success: 'Passwort geändert. Ihre anderen Sitzungen wurden abgemeldet.',
    errorCurrentWrong: 'Aktuelles Passwort ist falsch.',
    errorMismatch: 'Die beiden neuen Passwörter stimmen nicht überein.',
    errorTooShort: 'Das neue Passwort muss mindestens 8 Zeichen lang sein.',
    genericError: 'Ein Fehler ist aufgetreten. Bitte erneut versuchen.',
    apiKeys: {
      title: 'API-Schlüssel',
      intro:
        'Erstellen Sie Schlüssel, um mit einem externen Tool nur lesend auf Ihre Bibliothek zuzugreifen (API v1).',
      labelLabel: 'Bezeichnung des Schlüssels',
      labelPlaceholder: 'Z. B. Mein Export-Skript',
      create: 'Schlüssel erstellen',
      creating: 'Wird erstellt…',
      secretWarning: 'Kopieren Sie diesen Schlüssel jetzt: Er wird nicht erneut angezeigt.',
      copy: 'Kopieren',
      copied: 'Kopiert',
      loading: 'Wird geladen…',
      empty: 'Keine API-Schlüssel.',
      neverUsed: 'Nie verwendet',
      lastUsed: 'Zuletzt verwendet: {date}',
      revoked: 'Widerrufen',
      revoke: 'Widerrufen',
      confirmRevoke: 'Widerruf bestätigen',
      delete: 'Löschen',
      deleteConfirm: 'Löschen bestätigen',
      cancel: 'Abbrechen',
      errorLabel: 'Die Bezeichnung ist erforderlich.',
      errorGeneric: 'Schlüssel konnte nicht erstellt werden. Bitte erneut versuchen.',
      errorLoad: 'Schlüssel konnten nicht geladen werden.',
      docLink: 'API-Dokumentation ansehen (OpenAPI)',
    },
  },
  superadmin: {
    open: 'Superadmin',
    title: 'Superadmin',
  },
  sessionLinks: {
    tab: 'Zugangslinks',
    title: 'Zugangslinks',
    intro:
      'Ein Link öffnet ohne Passwort eine Sitzung für ein bestehendes Konto (Leser oder Mitwirkender). Geben Sie die URL niemals über einen öffentlichen Kanal weiter.',
    createTitle: 'Zugangslink erstellen',
    targetLabel: 'Zielkonto',
    chooseTarget: 'Konto auswählen…',
    labelLabel: 'Bezeichnung',
    labelPlaceholder: 'z. B. „Familie" oder „Fotoclub"',
    create: 'Link erstellen',
    creating: 'Wird erstellt…',
    writeWarning:
      'Achtung: Dieser Link gewährt SCHREIBZUGRIFF (Import, Löschung) an jeden, der ihn besitzt.',
    urlWarning: 'Kopieren Sie diese URL jetzt: Sie wird nie wieder angezeigt.',
    copy: 'URL kopieren',
    copied: 'Kopiert',
    errorNoTarget: 'Wählen Sie ein Zielkonto.',
    errorLabel: 'Geben Sie eine Bezeichnung an.',
    errorTarget:
      'Dieses Konto kann keinen Zugangslink erhalten (Superadmin-Konto oder ohne Bibliothek).',
    errorGeneric: 'Erstellung fehlgeschlagen. Bitte erneut versuchen.',
    errorLoad: 'Links konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
    loading: 'Wird geladen…',
    empty: 'Keine Zugangslinks.',
    created: 'Erstellt am {date}',
    lastUsed: 'zuletzt verwendet {date}',
    neverUsed: 'nie verwendet',
    active: 'Aktiv',
    revoked: 'Widerrufen',
    revoke: 'Widerrufen',
    revoking: 'Wird widerrufen…',
    confirmRevokeTitle: 'Diesen Link widerrufen?',
    confirmRevokeBody:
      'Der Link „{label}“ funktioniert sofort nicht mehr, und wer über diesen Link angemeldet ist, wird abgemeldet. Andere Links zum selben Konto sind nicht betroffen. Diese Aktion ist unwiderruflich.',
    cancel: 'Abbrechen',
  },
  admin: {
    open: 'Admin',
    title: 'Verwaltung',
    close: 'Schließen',
    tabGeneral: 'Allgemein',
    tabUsers: 'Konten',
    tabGrants: 'Zugriffe',
    loading: 'Wird geladen…',
    errorTitle: 'Laden fehlgeschlagen.',
    retry: 'Erneut versuchen',
    // Bereich Allgemein (Name der Website, LOT 3).
    general: {
      title: 'Allgemein',
      intro:
        'Name der Website, angezeigt im Browser-Tab, in der Fußzeile und bei der App-Installation.',
      appNameLabel: 'Name der Website',
      save: 'Speichern',
      saveAppNameAria: 'Speichern: Name der Website',
      saveGatewayAria: 'Speichern: Authentifizierungs-Gateway',
      saving: 'Wird gespeichert…',
      saved: 'Name der Website gespeichert.',
      error: 'Speichern fehlgeschlagen. Bitte erneut versuchen.',
      conflict:
        'Diese Einstellungen wurden zwischenzeitlich anderswo geändert. Laden Sie die Seite neu, bevor Sie speichern, um die Änderung des anderen Bearbeiters nicht zu überschreiben.',
      // Vergrösserung kleiner Fotos (Betrachter).
      upscaleTitle: 'Vergrösserung kleiner Fotos',
      upscaleIntro:
        'Auf grossen Bildschirmen wird ein Foto, das kleiner als das Fenster ist, im Betrachter bis zu diesem Prozentsatz vergrössert (100 % = Originalgrösse, keine Vergrösserung).',
      upscaleLabel: 'Maximale Vergrösserung (%)',
      upscaleHelp: 'Zwischen {min} und {max} %. Standardwert: 150 %.',
      saveUpscaleAria: 'Vergrösserung kleiner Fotos speichern',
      upscaleSaved: 'Vergrösserung gespeichert.',
      upscaleInvalid: 'Ungültiger Wert. Erwartet: eine ganze Zahl zwischen {min} und {max}.',
      // Authentifizierungs-Gateway (ADR-0008).
      gatewayTitle: 'Authentifizierungs-Gateway',
      gatewayIntro:
        'Ermöglicht Mitgliedern einer anderen Anwendung (zum Beispiel eines Forums), untereinander geteilte Fotolinks zu öffnen, ohne sich hier anmelden zu müssen. Feld leer lassen, um es zu deaktivieren: Besucher ohne Sitzung sehen dann wie bisher die Anmeldeseite.',
      gatewayLabel: 'URL des Gateways in der anderen Anwendung',
      gatewayPlaceholder: 'https://forum.beispiel.ch/fotos',
      gatewayHowTitle: 'Was diese Adresse in der anderen Anwendung tun muss:',
      gatewayStep1:
        'Nur für dort angemeldete Mitglieder erreichbar sein: Diese Anwendung weiss, wer der Besucher ist — wir nicht.',
      gatewayStep2:
        'Den Parameter «next» lesen, den wir übergeben: Er enthält die hier angeforderte Seite (zum Beispiel /dossiers?dossier=Trombis).',
      gatewayStep3:
        'Den Besucher auf diese Seite zurückleiten und dabei das Token eines Zugangslinks (?access=…) an die Adresse anhängen, das in ihrer Konfiguration hinterlegt ist. So zirkuliert das Token nie in den Links, die sich die Mitglieder teilen.',
      gatewayWarning:
        'Sicherheit: Die andere Anwendung muss jedes «next» ablehnen, das kein mit einem einzelnen Schrägstrich beginnender Pfad ist — sonst kann das Token auf eine fremde Website umgeleitet werden.',
      gatewaySaved: 'Gateway gespeichert.',
      gatewayDisabled: 'Gateway deaktiviert.',
      gatewayInvalid:
        'Ungültige Adresse. Erwartet: eine URL, die mit http:// oder https:// beginnt.',
    },
    usersTitle: 'Benutzerkonten',
    usersHint: 'Konten anlegen, Rolle ändern oder löschen.',
    usersEmpty: 'Keine Konten.',
    colEmail: 'E-Mail',
    colName: 'Name',
    colRole: 'Rolle',
    colActions: 'Aktionen',
    createUserTitle: 'Konto erstellen',
    fieldEmail: 'E-Mail-Adresse',
    fieldName: 'Anzeigename',
    fieldRole: 'Rolle',
    fieldPassword: 'Passwort',
    grantFullRead: 'Lesezugriff auf die gesamte Bibliothek',
    grantFullReadHint:
      'Abwählen für einen auf einen Unterordner beschränkten Leser (danach unter „Zugriff“ festzulegen).',
    adminWriteHint: 'Ein Administrator hat Schreibzugriff auf die gesamte Bibliothek.',
    create: 'Erstellen',
    creating: 'Wird erstellt…',
    userCreated: 'Konto erstellt.',
    editRole: 'Rolle von {name} ändern',
    delete: 'Löschen',
    deleting: 'Wird gelöscht…',
    confirmDeleteTitle: 'Konto löschen',
    confirmDelete: 'Konto {name} löschen? Diese Aktion ist unwiderruflich.',
    cancel: 'Abbrechen',
    // Passwort-Zurücksetzung durch den Superadmin (aufdeckbares Inline-Feld).
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordFor: 'Neues Passwort für {name}',
    resetPasswordPlaceholder: 'Neues Passwort (min. 8)',
    resetPasswordSubmit: 'Bestätigen',
    resettingPassword: 'Wird zurückgesetzt…',
    resetPasswordDone: 'Passwort zurückgesetzt. Die Sitzungen dieses Kontos wurden abgemeldet.',
    resetPasswordError: 'Zurücksetzen fehlgeschlagen. Bitte erneut versuchen.',
    conflictUser: 'Dieses Konto steht im Konflikt mit einem bestehenden Konto.',
    conflictEmail: 'Diese E-Mail-Adresse wird bereits verwendet.',
    conflictLastAdmin: 'Nicht möglich: letzter Superadmin.',
    cannotDeleteSelf: 'Sie können Ihr eigenes Konto nicht löschen.',
    deleteSelfDisabled: 'Ihr Konto',
    genericError: 'Ein Fehler ist aufgetreten. Bitte erneut versuchen.',
    grantsTitle: 'Zugriff auf die Bibliothek',
    grantsHint: 'Gewähren Sie LESEZUGRIFF auf einen Teilbaum der Bibliothek.',
    grantsReadOnly:
      'Diese Zugriffe sind schreibgeschützt: Der Empfänger kann weder ändern noch löschen.',
    grantsEmpty: 'Keine Zugriffe gewährt.',
    noLibrarySelected: 'Ihrem Konto ist keine Bibliothek zugeordnet.',
    colBeneficiary: 'Empfänger',
    colSubtree: 'Teilbaum',
    subtreeRoot: 'Stamm (gesamte Bibliothek)',
    createGrantTitle: 'Zugriff gewähren',
    fieldBeneficiary: 'Empfänger',
    fieldUserId: 'Benutzerkennung',
    chooseBeneficiary: 'Empfänger auswählen…',
    fieldSubtree: 'Teilbaum (Pfadpräfix)',
    subtreePlaceholder: 'z. B. 2024/urlaub (leer = Stamm)',
    grant: 'Gewähren',
    granting: 'Wird gewährt…',
    grantCreated: 'Zugriff gewährt.',
    revoke: 'Widerrufen',
    revoking: 'Wird widerrufen…',
    confirmRevokeTitle: 'Zugriff widerrufen',
    confirmRevoke: 'Zugriff von {name} widerrufen?',
    conflictGrant: 'Dieser Zugriff besteht bereits.',
    notFoundUser: 'Benutzer nicht gefunden.',
    // Vereinheitlichte Löschsteuerung (wiederverwendbar — Dateifehler UND Anfragen).
    purge: {
      dateLabel: 'Bis zu diesem Datum (einschließlich)',
      button: 'Bis zu diesem Datum löschen',
      title: 'Einträge löschen',
      confirm: 'Alle Einträge bis einschließlich {date} löschen? Diese Aktion ist unwiderruflich.',
      confirmButton: 'Löschen',
      cancel: 'Abbrechen',
      purging: 'Wird gelöscht…',
      purged: '{count} Eintrag/Einträge gelöscht.',
      invalidDate: 'Ungültiges Datum.',
      error: 'Löschen fehlgeschlagen. Bitte erneut versuchen.',
    },
    // Abschnitt Protokolle (Superadmin) — Protokollierung aller Anfragen.
    audit: {
      tab: 'Audit',
      title: 'Audit-Protokoll',
      intro:
        'Wer hat was getan: Anmeldungen, Passwortänderungen und Verarbeitungen (Verschieben, EXIF-Löschung, Papierkorb leeren, Komprimierung…) samt Urheber.',
      retention:
        'Automatische Aufbewahrung: 24 Monate. Dieses Protokoll kann auf dieser Seite nicht gelöscht werden.',
      empty: 'Keine Einträge im Protokoll.',
      colTimestamp: 'Zeitstempel',
      colAction: 'Aktion',
      colUser: 'Urheber',
      colSummary: 'Zusammenfassung',
      colDetails: 'Details',
      noUser: 'Nicht zugeordnet',
      dryRun: 'Simulation (keine Änderung)',
      showDetails: 'Details anzeigen',
      detailsUnreadable: 'Details nicht lesbar',
      previous: 'Zurück',
      next: 'Weiter',
      range: '{from}–{to} von {total}',
      filterAction: 'Aktion',
      filterUser: 'Urheber',
      filterFrom: 'Von',
      filterTo: 'Bis',
      actionAll: 'Alle Aktionen',
      userAll: 'Alle Urheber',
    },
    sessions: {
      button: 'Sitzungen',
      count: '{count} aktive Sitzung(en)',
      empty: 'Keine aktive Sitzung.',
      loadError: 'Sitzungen konnten nicht geladen werden.',
      unknownAgent: 'Unbekanntes Gerät',
      unknownLink: 'gelöschter Link',
      lastUsed: 'Letzte Aktivität: {when}',
      expires: 'Läuft ab am {when}',
      viaLink: 'Eingetreten über den Link « {label} »',
      current: 'Ihre aktuelle Sitzung',
      revoke: 'Widerrufen',
      revoking: 'Widerrufen…',
      revokeError: 'Widerruf fehlgeschlagen. Bitte erneut versuchen.',
    },
    logs: {
      tab: 'Protokolle',
      title: 'Anfrageprotokolle',
      intro: 'Alle API-Anfragen werden protokolliert (Methode, Pfad, Status, Dauer, Benutzer).',
      retention: 'Automatische Aufbewahrung: 3 Monate.',
      empty: 'Keine Einträge im Protokoll.',
      colTimestamp: 'Zeitstempel',
      colMethod: 'Methode',
      colPath: 'Pfad',
      colStatus: 'Status',
      colUser: 'Benutzer',
      colDuration: 'Dauer',
      colError: 'Fehler',
      noUser: '—',
      duration: '{ms} ms',
      statusSuccess: 'Erfolg',
      statusRedirect: 'Weiterleitung',
      statusClientError: 'Client-Fehler',
      statusServerError: 'Server-Fehler',
      previous: 'Zurück',
      next: 'Weiter',
      range: '{from}–{to} von {total}',
      // Filterleiste (Benutzer / Status = HTTP-Klasse / Methode = Verb).
      filterUser: 'Benutzer',
      filterStatus: 'Status',
      filterMethod: 'Methode',
      userAll: 'Alle Benutzer',
      statusAll: 'Alle Status',
      status2xx: '2xx (Erfolg)',
      status3xx: '3xx (Weiterleitung)',
      status4xx: '4xx (Client-Fehler)',
      status5xx: '5xx (Server-Fehler)',
      methodAll: 'Alle Methoden',
      methodGet: 'GET',
      methodPost: 'POST',
      methodPatch: 'PATCH',
      methodDelete: 'DELETE',
    },
    // Abschnitt Dateifehler (Los C) — Protokoll fehlgeschlagener Verarbeitungen.
    fileErrors: {
      tab: 'Dateifehler',
      title: 'Fehler bei der Dateiverarbeitung',
      intro:
        'Fehler und Anomalien bei der Verarbeitung (Scan, Verschieben, EXIF, Deduplizierung): unlesbare Datei, ungültiges Format (z. B. PDF mit Endung .png), fehlgeschlagenes Vorschaubild…',
      empty: 'Keine Fehler protokolliert.',
      noValue: '—',
      previous: 'Zurück',
      next: 'Weiter',
      range: '{from}–{to} von {total}',
      // Spalten.
      colTimestamp: 'Zeitstempel',
      colSeverity: 'Status',
      colMethod: 'Methode',
      colUser: 'Benutzer',
      colPath: 'Relativer Pfad',
      colMime: 'Erkannter MIME',
      colMessage: 'Meldung',
      // Filterleiste.
      filterUser: 'Benutzer',
      filterStatus: 'Status',
      filterMethod: 'Methode',
      userAll: 'Alle Benutzer',
      statusAll: 'Alle Status',
      statusError: 'Fehler',
      statusSkipped: 'Übersprungen',
      statusWarning: 'Warnungen',
      methodAll: 'Alle Methoden',
      methodScan: 'Scan',
      methodMove: 'Verschieben',
      methodExif: 'EXIF',
      methodDedup: 'Deduplizierung',
      methodTrash: 'Papierkorb leeren',
      // Job-Typ-Bezeichnungen in der Tabelle.
      jobScan: 'Scan',
      jobThumbnail: 'Vorschaubild',
      jobAiTag: 'KI-Tag',
      jobDedup: 'Deduplizierung',
      jobDedupApply: 'Duplikate löschen',
      jobDedupExactApply: 'Exakte Kopien löschen',
      jobExifPublish: 'EXIF veröffentlichen',
      jobExifErase: 'EXIF löschen',
      jobMove: 'Verschieben',
      jobCompress: 'Komprimierung',
      jobRotate: 'Drehung',
      jobOriginalsCleanup: '_original-Bereinigung',
      jobTrashPurge: 'Papierkorb leeren',
      jobRenameExtensions: 'Endungskorrektur',
      jobEmptyFoldersCleanup: 'Leere Ordner aufräumen',
      // Abgleich Datenträger ↔ Index (letzter Scan).
      reconTitle: 'Abgleich des letzten Scans',
      reconSummary:
        '{walked} Dateien auf dem Datenträger = {indexed} indexiert (in der Galerie) + {collapsed} zusammengeführte exakte Kopien + {skipped} übersprungen.',
      reconWhen: 'Letzter Scan abgeschlossen am {when}.',
      reconWhenDry: 'Letzte Vorschau (Probelauf) am {when}.',
      reconWalked: 'Dateien auf dem Datenträger',
      reconIndexed: 'Indexierte Medien (in der Galerie)',
      reconCollapsed: 'Zusammengeführte exakte Kopien',
      reconSkipped: 'Übersprungene Dateien',
      reconByReason: 'Übersprungen, nach Grund',
      reconUnaccounted:
        'Ungeklärte Abweichung: {count} (Scan erneut ausführen, um zu aktualisieren).',
      reconReasonUnsupported: 'Nicht unterstützte Erweiterung',
      reconReasonNonMedia: 'Keine Mediendatei (Beilage / System)',
      reconReasonUnreadable: 'Datei nicht lesbar',
      reconReasonDecode: 'Dekodierung / Verarbeitung fehlgeschlagen',
      reconReasonMismatched: 'Typkonflikt (z. B. PDF mit Endung .png)',
      // Aufschlüsselung nicht unterstützter Endungen + TXT-Exporte.
      reconExtensionsTitle: 'Nicht unterstützte Endungen, nach Häufigkeit',
      reconExtensionNone: '(ohne Endung)',
      reconDownloadSkipped: 'Liste der ignorierten Dateien herunterladen (.txt)',
      reconDownloadNonMedia: 'Nicht-Mediendateien herunterladen (.txt)',
    },
    // Bereich Wartung (Superadmin) — Zurücksetzen „von vorne beginnen".
    reset: {
      tab: 'Wartung',
      title: 'Bibliothek zurücksetzen',
      intro:
        'Beginnen Sie von vorne, um den Galerie-Einstieg und die Vorschaubild-Erzeugung erneut zu testen. Ein neuer Scan baut alles wieder auf.',
      deletes: 'Wird gelöscht: der Medienindex (Datenbank) und die Vorschaubilder (Cache).',
      preserves:
        'Wird bewahrt: Ihre ORIGINALDATEIEN und deren EXIF-Metadaten (nie berührt), die Konten, die Bibliothek und die Zugriffe.',
      button: 'Alles zurücksetzen',
      // Schwere Bestätigungsdialog.
      modalTitle: 'Bibliothek zurücksetzen?',
      modalWarning:
        'Diese Aktion ist UNWIDERRUFLICH. Sie leert den Medienindex und löscht alle Vorschaubilder.',
      modalSafe:
        'Keine Originaldatei wird geändert oder gelöscht, und keine EXIF-Metadaten auf der Festplatte werden berührt: Das Zurücksetzen betrifft nur die Datenbank und den Vorschaubild-Cache.',
      confirmLabel: 'Geben Sie zur Bestätigung unten {word} ein.',
      confirmWord: 'ZURUCKSETZEN',
      confirmPlaceholder: 'Bestätigungswort eingeben',
      confirm: 'Endgültig zurücksetzen',
      resetting: 'Wird zurückgesetzt…',
      cancel: 'Abbrechen',
      close: 'Schließen',
      done: 'Zurücksetzen abgeschlossen: {assets} Medium/Medien und {thumbnails} Vorschaubild(er) gelöscht. Sie können einen Scan starten.',
      error: 'Das Zurücksetzen ist fehlgeschlagen. Erneut versuchen.',
    },
    // Bereich Papierkorb (Los 2) — Verwaltung des Papierkorbs (Soft-Delete + endgültige Löschung).
    // Bereich „Fehlende Dateien“ (Audit A5) — Medien, deren Datei von der Platte verschwand.
    missingFiles: {
      tab: 'Fehlende Dateien',
      title: 'Fehlende Dateien',
      intro:
        'Indexierte Medien, deren Datei von der Festplatte VERSCHWUNDEN ist. Sie sind in der gesamten Galerie ausgeblendet: nur hier lassen sie sich noch bearbeiten.',
      hint: 'In den Papierkorb verschieben und diesen dann leeren (Reiter „Papierkorb“), um Eintrag und Miniaturen endgültig zu löschen. Keine Datei wird angefasst: es gibt keine mehr.',
      empty: 'Keine fehlenden Dateien. Der Index entspricht der Festplatte.',
      error: 'Der Vorgang ist fehlgeschlagen. Bitte erneut versuchen.',
      errorForbidden: 'Vorgang abgelehnt: nur Lesezugriff.',
      trashSelected: 'In den Papierkorb ({count})',
      trashed: '{count} Medium/Medien in den Papierkorb verschoben.',
      refresh: 'Aktualisieren',
      selectAll: 'Alle Zeilen dieser Seite auswählen',
      selectOne: '{name} auswählen',
      colPath: 'Pfad',
      colSize: 'Größe',
      colSeenAt: 'Zuletzt gesehen',
      seenUnknown: 'Unbekannt',
      range: '{from}–{to} von {total}',
      previous: 'Zurück',
      next: 'Weiter',
    },
    trash: {
      tab: 'Papierkorb',
      title: 'Papierkorb',
      intro:
        'In den Papierkorb verschobene Medien: wiederherstellen oder ENDGÜLTIG löschen (Datei wird von der Festplatte entfernt, unwiderruflich).',
      empty: 'Der Papierkorb ist leer.',
      error: 'Der Vorgang ist fehlgeschlagen. Erneut versuchen.',
      errorWriteDisabled:
        'Löschen nicht möglich: Die Bibliothek ist schreibgeschützt eingebunden (Schreiben deaktiviert).',
      restoreSelected: 'Auswahl wiederherstellen ({count})',
      restored: '{count} Medium/Medien wiederhergestellt.',
      purgeSelected: 'Endgültig löschen ({count})',
      purgeAll: 'Papierkorb leeren',
      purgeQueued: 'Löschung gestartet — verfolgen Sie den Fortschritt in den Benachrichtigungen.',
      purging: 'Wird gelöscht…',
      cancel: 'Abbrechen',
      confirmTitle: 'Endgültig löschen?',
      confirmButton: 'Endgültig löschen',
      confirmWarning:
        'Diese Aktion ist UNWIDERRUFLICH: Die Dateien werden von der Festplatte GELÖSCHT und aus der Datenbank entfernt.',
      confirmAll: '{count} Medium/Medien im Papierkorb werden endgültig gelöscht.',
      confirmSelection: '{count} ausgewählte(s) Medium/Medien werden endgültig gelöscht.',
      deletedWhen: 'Gelöscht am {when}',
      range: '{from}–{to} von {total}',
      previous: 'Zurück',
      next: 'Weiter',
    },
  },
  bugReport: {
    open: 'Fehler melden',
    title: 'Fehler melden',
    close: 'Schließen',
    intro:
      'Kopieren Sie diesen Bericht (oder laden Sie ihn als .json herunter) und senden Sie ihn, wie Sie möchten. Es wird nichts automatisch übertragen.',
    descriptionLabel: 'Beschreibung (von Ihnen auszufüllen)',
    descriptionPlaceholder: 'Beschreiben Sie, was passiert ist und was Sie erwartet haben …',
    technicalLabel: 'Technischer Kontext (schreibgeschützt)',
    noPasswords: 'Dieser Bericht enthält nicht Ihre Passwörter.',
    copy: 'Kopieren',
    copied: 'Kopiert!',
    download: '.json herunterladen',
    crashTitle: 'In der Anwendung ist ein Fehler aufgetreten',
    crashHint: 'Sie können die Seite neu laden oder das Problem melden.',
    crashHintInline:
      'Bei dieser Ansicht ist ein Fehler aufgetreten. Sie können woanders hinnavigieren, neu laden oder das Problem melden.',
    reload: 'Neu laden',
  },
  notifications: {
    open: 'Benachrichtigungen ({count} laufend)',
    title: 'Aktivität',
    empty: 'Keine Aktivität',
    loading: 'Aktivität wird geladen…',
    error: 'Aktivität konnte nicht geladen werden',
    clearAll: 'Alle entfernen',
    dismiss: 'Entfernen',
    cancel: 'Abbrechen',
    progress: '{done}/{total}',
    cancelForbidden: 'Nur-Lese-Zugriff: Abbrechen nicht möglich',
    cancelFailed: 'Abbrechen fehlgeschlagen. Bitte erneut versuchen.',
    retry: 'Erneut starten',
    retrying: 'Wird gestartet…',
    retryQueued: 'Erneut gestartet: die Verarbeitung läuft wieder.',
    retryForbidden: 'Nur-Lese-Zugriff: erneutes Starten nicht möglich',
    retryAlreadyRunning: 'Eine Verarbeitung desselben Typs läuft bereits.',
    retryNotRetryable: 'Dieser Verarbeitungstyp kann nicht automatisch erneut gestartet werden.',
    retryFailed: 'Erneutes Starten fehlgeschlagen. Bitte erneut versuchen.',
    eta: 'Voraussichtlich fertig in {eta}',
    etaSeconds: '≈ {value} s',
    etaMinutes: '≈ {value} min',
    startedAt: 'Gestartet um {time}',
    ranRange: '{start} → {end}',
    typeScan: 'Scan',
    typeThumbnail: 'Miniaturbild-Erstellung',
    typeAiTag: 'KI-Tagging',
    typeDedup: 'Duplikatsuche',
    typeDedupApply: 'Duplikate entfernen',
    typeDedupExactApply: 'Exakte Kopien entfernen',
    typeExifPublish: 'EXIF veröffentlichen',
    typeExifErase: 'EXIF löschen',
    typeMove: 'Dateien verschieben',
    typeCompress: 'Verlustfreie Komprimierung',
    typeRotate: 'Drehung',
    typeOriginalsCleanup: '_original-Sicherungen bereinigen',
    typeTrashPurge: 'Papierkorb leeren',
    typeRenameExtensions: 'Dateiendungen korrigieren',
    typeEmptyFoldersCleanup: 'Leere Ordner aufräumen',
    statusQueued: 'In Warteschlange',
    statusRunning: 'Läuft',
    statusDone: 'Fertig',
    statusFailed: 'Fehlgeschlagen',
    statusCanceled: 'Abgebrochen',
    doneNoResult: 'Ohne Ergebnis beendet',
    doneNoResultHint: 'Alle Vorgänge sind fehlgeschlagen. Siehe Admin › Dateifehler.',
    reviewAiTags: 'KI-Tags prüfen',
    refreshGallery: 'Galerie aktualisieren',
    // Zusammenfassungen des Ergebnisses eines beendeten Jobs (Glocke).
    resultCompressed: '{count} komprimiert',
    resultBytesSaved: '{bytes} eingespart',
    resultNoGain: 'Kein Gewinn',
    resultPotentialGain: 'Simulation · möglicher Gewinn {bytes} von {total}',
    resultSkipped: '{count} übersprungen',
    resultFailed: '{count} Fehler',
    resultMoved: '{count} verschoben',
    resultRotated: '{count} gedreht',
    resultRenamed: '{count} umbenannt',
    resultConflicts: '{count} Konflikt(e)',
    resultPurged: '{count} gelöscht',
    resultMissing: '{count} fehlend',
    resultFoldersRemoved: '{count} Ordner entfernt',
    resultSystemFilesRemoved: '{count} Systemdatei(en) gelöscht',
  },
  organize: {
    moveWithAudio: 'Videos mit Ton verschieben…',
    moveSelection: 'Auswahl verschieben…',
    moveTitle: 'In Ordner verschieben',
    moveWithAudioIntro:
      'Alle Videos mit Tonspur in einen Ordner der Bibliothek verschieben. Die Dateien werden verschoben (nicht kopiert).',
    moveSelectionIntro:
      'Die {count} ausgewählten Medien in einen Ordner der Bibliothek verschieben. Die Dateien werden verschoben (nicht kopiert).',
    // Ziel: Ordnerbaum + Karte „Neuer Ordner hier“ (wie beim Hochladen).
    destLabel: 'Zielordner',
    destSelected: 'Ausgewähltes Ziel',
    newFolderHere: 'Neuer Ordner hier',
    searchPlaceholder: 'Ordner suchen…',
    loadingFolders: 'Ordner werden geladen…',
    foldersError: 'Ordner konnten nicht geladen werden.',
    selectFolder: 'Ordner {name} wählen',
    folderCount: '{count} Datei(en)',
    expandFolder: '{name} aufklappen',
    collapseFolder: '{name} zuklappen',
    searchEmpty: 'Kein Ordner entspricht dieser Suche',
    newFolderConfirm: 'Einen Ordner in „{parent}“ erstellen?',
    newFolderCreate: 'Hier erstellen',
    newFolderLabel: 'Neuer Ordner',
    newFolderPreview: 'Wird erstellt: {path}',
    destPlaceholder: 'z. B. with_sound',
    destHint:
      'Relativer Pfad unterhalb des Bibliotheks-Stammverzeichnisses (Unterordner mit / erlaubt).',
    destInvalid: 'Ungültiger Ordner (kein absoluter Pfad und kein „..“).',
    submit: 'Verschieben',
    submitting: 'Wird eingereiht…',
    cancel: 'Abbrechen',
    close: 'Schließen',
    success: 'Verschiebung eingereiht. Fortschritt in der Benachrichtigungsglocke verfolgen.',
    errorWriteDisabled: 'Schreiben auf der Bibliothek deaktiviert (nur lesend eingebunden).',
    error: 'Die Verschiebung ist fehlgeschlagen. Bitte erneut versuchen.',
  },
  // XPHOTO-32 (Los 4): Schreiboperationen auf ORDNERN — erstellen, umbenennen, verschieben.
  folderOps: {
    newFolder: 'Neuer Ordner',
    menuLabel: 'Aktionen für Ordner {name}',
    actionRename: 'Umbenennen…',
    actionMove: 'Verschieben nach…',
    actionCreateChild: 'Neuer Unterordner…',
    actionDelete: 'Löschen…',
    createTitle: 'Neuer Ordner',
    renameTitle: 'Ordner umbenennen',
    moveTitle: 'Ordner verschieben',
    deleteTitle: 'Ordner löschen',
    createIntro: 'Erstellt einen Unterordner in „{folder}“.',
    renameIntro: 'Benennt „{folder}“ um. Der Ordner bleibt an seinem Platz.',
    moveIntro: 'Verschiebt „{folder}“ unter einen anderen Ordner. Der Name bleibt erhalten.',
    deleteIntro: 'Löscht „{folder}“ und alle seine Unterordner. Dieser Vorgang ist endgültig.',
    nameLabel: 'Ordnername',
    namePlaceholder: 'z. B. urlaub',
    nameHint: 'Nur ein Ordnername, ohne „/“ und ohne „\\“.',
    nameInvalid:
      'Ungültiger Name (kein „/“, kein „\\“, kein „..“ und kein Name, der mit einem Punkt beginnt).',
    preview: 'Resultierender Pfad: {path}',
    destLabel: 'Zielordner',
    createSubmit: 'Erstellen',
    renameSubmit: 'Umbenennen',
    moveSubmit: 'Verschieben',
    deleteSubmit: 'Löschen',
    deleteScanning: 'Ordner wird geprüft…',
    deletePreviewError:
      'Dieser Ordner konnte nicht geprüft werden. Bitte das Fenster schliessen und erneut versuchen.',
    deleteSafetyNote:
      'Es werden ausschliesslich LEERE Verzeichnisse gelöscht: kein Foto, kein Video und keine Datei kann dabei verloren gehen — mit der einzigen Ausnahme der unten aufgeführten Systemdateien, und auch nur, wenn Sie es erlauben.',
    deleteBlockedTitle: 'Dieser Ordner kann nicht gelöscht werden:',
    blockerIndexedAssets_one:
      '{count} Medium ist in diesem Ordner noch indexiert. Leeren Sie ihn, oder bereinigen Sie den Index in der Admin-Konsole („Papierkorb“, „Fehlende Dateien“).',
    blockerIndexedAssets_other:
      '{count} Medien sind in diesem Ordner noch indexiert. Leeren Sie ihn, oder bereinigen Sie den Index in der Admin-Konsole („Papierkorb“, „Fehlende Dateien“).',
    blockerOtherFiles:
      'Er enthält noch Dateien. Bitte zuerst verschieben oder löschen — dieses Produkt löscht niemals eine Datei an Ihrer Stelle.',
    blockerHiddenDir:
      'Er enthält einen versteckten Ordner (zum Beispiel „.stfolder“ von Syncthing). Solche Ordner sind Markierungen und werden nie gelöscht.',
    blockerUnreadable: 'Einer seiner Unterordner konnte nicht gelesen werden (Zugriffsrechte).',
    deleteFolderCount_one: '{count} Verzeichnis wird gelöscht.',
    deleteFolderCount_other: '{count} Verzeichnisse werden gelöscht.',
    deleteSystemCount_one: '{count} Systemdatei verhindert als Einzige das Löschen.',
    deleteSystemCount_other: '{count} Systemdateien verhindern als Einzige das Löschen.',
    deleteSystemNames: 'Betroffene Dateien: {names}.',
    deleteSystemOptIn: 'Diese Systemdateien ebenfalls löschen',
    // Wort OHNE Umlaut: auf einer Schweizer Tastatur sind akzentuierte Grossbuchstaben
    // muehsam. Der Vergleich bleibt tolerant gegenueber Umlauten und Gross-/Kleinschreibung.
    deleteConfirmWord: 'LOSCHEN',
    deleteConfirmLabel: 'Zur Bestätigung „{word}“ abtippen:',
    impactIntro: 'Wird automatisch mitgeführt:',
    impactAssets_one: '{count} Medium',
    impactAssets_other: '{count} Medien',
    impactShares_one: '{count} öffentliche Freigabe',
    impactShares_other: '{count} öffentliche Freigaben',
    impactGrants_one: '{count} Zugriff',
    impactGrants_other: '{count} Zugriffe',
    savedFiltersWarning_one:
      '{count} gespeicherter Filter verweist auf diesen Ordner: sein Ausdruck wird NICHT aktualisiert und funktioniert danach nicht mehr.',
    savedFiltersWarning_other:
      '{count} gespeicherte Filter verweisen auf diesen Ordner: ihre Ausdrücke werden NICHT aktualisiert und funktionieren danach nicht mehr.',
    errorWriteDisabled: 'Schreiben auf der Bibliothek deaktiviert (nur lesend eingebunden).',
    errorConflict:
      'An dieser Stelle gibt es bereits einen Ordner mit diesem Namen. Es wurde nichts geändert.',
    errorCrossDevice:
      'Das Ziel liegt auf einem anderen Datenträger: diese Verschiebung wird nicht unterstützt.',
    errorOutOfSync:
      'Der Ordner wurde auf der Festplatte umbenannt, die Datenbank ist aber nicht gefolgt. Bitte eine Analyse der Bibliothek starten.',
    errorNotEmpty:
      'Der Ordner ist nicht mehr leer: sein Inhalt hat sich seit der Prüfung geändert. Es wurde nichts gelöscht — bitte dieses Fenster erneut öffnen, um den aktuellen Stand zu sehen.',
    errorHasAssets:
      'In diesem Ordner sind noch Medien indexiert. Leeren Sie ihn, oder bereinigen Sie den Index in der Admin-Konsole („Papierkorb“, „Fehlende Dateien“), und versuchen Sie es erneut.',
    errorInvalid: 'Ungültiger Name oder ungültiges Ziel.',
    errorGeneric: 'Der Vorgang ist fehlgeschlagen. Bitte erneut versuchen.',
  },
  compress: {
    action: 'Auswahl komprimieren…',
    title: 'Auswahl komprimieren',
    intro: 'Verkleinert die {count} ausgewählten Medien ohne jeglichen Qualitätsverlust.',
    losslessNote:
      'VERLUSTFREIE Komprimierung (identische Pixel) — nur JPEG- und PNG-Bilder; Videos werden übersprungen. Eine Datei wird nur ersetzt, wenn sie kleiner wird.',
    keepOriginal: 'Sicherung „_original“ behalten',
    dryRun: 'Zuerst simulieren (Vorschau der Ersparnis, ohne zu schreiben)',
    confirm: 'Komprimieren',
    submitting: 'Wird eingereiht…',
    cancel: 'Abbrechen',
    close: 'Schließen',
    queued: 'Komprimierung eingereiht. Fortschritt in der Benachrichtigungsglocke verfolgen.',
    errorWriteDisabled: 'Schreiben auf der Bibliothek deaktiviert (nur lesend eingebunden).',
    error: 'Die Komprimierung ist fehlgeschlagen. Bitte erneut versuchen.',
  },
  rotate: {
    // Eintrag im Aktionsmenü + Dialog „Drehen“ (Rotation über das EXIF-Tag Orientation).
    action: 'Auswahl drehen…',
    title: 'Auswahl drehen',
    intro: 'Dreht die {count} ausgewählten Medien, indem ihre Ausrichtung geschrieben wird.',
    exifNote:
      'Die Drehung schreibt NUR das EXIF-Ausrichtungs-Tag der Originale — die Pixel werden nie verändert (kein Qualitätsverlust). Videos werden übersprungen.',
    cw: 'Nach rechts drehen (90°)',
    ccw: 'Nach links drehen (90°)',
    flip: 'Umdrehen (180°)',
    dryRun: 'Zuerst simulieren (Vorschau, ohne zu schreiben)',
    queued: 'Drehung eingereiht. Fortschritt in der Benachrichtigungsglocke verfolgen.',
    cancel: 'Abbrechen',
    close: 'Schließen',
    errorWriteDisabled: 'Schreiben auf der Bibliothek deaktiviert (nur lesend eingebunden).',
    error: 'Die Drehung ist fehlgeschlagen. Bitte erneut versuchen.',
  },
  fixExtensions: {
    // Dialog „Dateiendungen korrigieren“ (gesamte Bibliothek).
    title: 'Dateiendungen korrigieren',
    intro:
      'Benennt Dateien, deren Endung nicht zum tatsächlichen Typ passt (ein echtes JPEG namens „.png“, ein WebP namens „.jpg“, ein WEBM-Video namens „.mp4“…), auf die richtige Endung um.',
    note: 'Der INHALT der Datei wird nicht verändert (reine Umbenennung). Bei einem Namenskonflikt wird ein Suffix „(1)“ angehängt — es wird nie eine Datei überschrieben.',
    scanning: 'Wird analysiert…',
    scanError: 'Die Analyse ist fehlgeschlagen.',
    retry: 'Erneut versuchen',
    none: 'Keine falsch benannten Dateien: alle Endungen passen zum Inhalt.',
    count: '{count} Datei(en) zu korrigieren:',
    andMore: '… und {count} weitere.',
    confirm: '{count} Datei(en) korrigieren',
    submitting: 'Wird eingereiht…',
    cancel: 'Abbrechen',
    close: 'Schließen',
    queued: 'Korrektur eingereiht. Fortschritt in der Benachrichtigungsglocke verfolgen.',
    errorWriteDisabled: 'Schreiben auf der Bibliothek deaktiviert (nur lesend eingebunden).',
    error: 'Die Korrektur ist fehlgeschlagen. Bitte erneut versuchen.',
  },
  cleanEmptyFolders: {
    // Dialog „Leere Ordner aufräumen“ (gesamte Bibliothek).
    title: 'Leere Ordner aufräumen',
    intro:
      'Entfernt auf dem Datenträger die Ordner, die keine Datei mehr enthalten — jene, die nach einem Verschieben, einer Papierkorb-Leerung oder einem manuellen Aufräumen zurückbleiben. Diese Ordner erscheinen nirgends in xphoto: die Ordnerliste wird aus den Fotos abgeleitet.',
    note: 'Es wird nie eine Datei gelöscht: das Werkzeug entfernt ausschließlich leere Ordner. Versteckte Ordner (mit einem Punkt am Anfang) bleiben unangetastet — sie sind oft Marker von Synchronisierungswerkzeugen.',
    scanning: 'Wird analysiert…',
    scanError: 'Die Analyse ist fehlgeschlagen.',
    retry: 'Erneut versuchen',
    none: 'Keine leeren Ordner: nichts aufzuräumen.',
    count: '{count} leere(r) Ordner zu entfernen:',
    systemCount: '{count} Ordner, die nur Systemdateien enthalten:',
    systemNote:
      'Diese Ordner wirken leer, doch Ihr Betriebssystem hat dort eine Datei hinterlassen ({names}). Sie werden ohne Ihre Zustimmung NICHT entfernt.',
    systemOptIn: 'Diese Systemdateien ebenfalls löschen und die Ordner entfernen',
    andMore: '… und {count} weitere.',
    confirm: '{count} Ordner entfernen',
    submitting: 'Wird eingereiht…',
    cancel: 'Abbrechen',
    close: 'Schließen',
    queued: 'Aufräumen eingereiht. Fortschritt in der Benachrichtigungsglocke verfolgen.',
    errorWriteDisabled: 'Schreiben auf der Bibliothek deaktiviert (nur lesend eingebunden).',
    error: 'Das Aufräumen ist fehlgeschlagen. Bitte erneut versuchen.',
  },
  upload: {
    title: 'Dateien hochladen',
    enlarge: 'Fenster vergrößern',
    reduce: 'Fenster verkleinern',
    intro:
      'Fügen Sie Fotos oder Videos zur Bibliothek hinzu. Die Dateien werden in den gewählten Ordner kopiert und dann indexiert (in der Glocke verfolgen).',
    heicNote:
      'HEIC-Fotos (iPhone) werden beim Import in WebP umgewandelt, da Browser HEIC nicht anzeigen können: Das HEIC-Original wird NICHT aufbewahrt. Die Umwandlung ist unumkehrbar und geht mit einem geringen Qualitätsverlust einher.',
    dropHint: 'Dateien hierher ziehen oder auswählen.',
    chooseFiles: 'Dateien auswählen',
    selectedCount: '{count} Datei(en) ausgewählt',
    removeFile: '{name} entfernen',
    destLabel: 'Zielordner',
    destSelected: 'Ausgewähltes Ziel',
    newFolderHere: 'Neuer Ordner hier',
    searchPlaceholder: 'Ordner suchen…',
    loadingFolders: 'Ordner werden geladen…',
    foldersError: 'Ordner konnten nicht geladen werden.',
    selectFolder: 'Ordner {name} wählen',
    folderCount: '{count} Datei(en)',
    expandFolder: '{name} aufklappen',
    collapseFolder: '{name} zuklappen',
    searchEmpty: 'Kein Ordner entspricht dieser Suche',
    newFolderConfirm: 'Einen Ordner in „{parent}“ erstellen?',
    newFolderCreate: 'Hier erstellen',
    newFolderNameLabel: 'Name des neuen Ordners',
    newFolderNamePlaceholder: 'z. B. 2026',
    newFolderNameHint: 'Geben Sie den Namen des Ordners ein, der am gewählten Ort erstellt wird.',
    newFolderPreview: 'Wird erstellt: {path}',
    destInvalid: 'Ungültiger Ordner (kein absoluter Pfad und kein „..“).',
    submit: 'Hochladen',
    uploading: 'Wird hochgeladen…',
    cancel: 'Abbrechen',
    close: 'Schließen',
    resultUploaded: '{count} Datei(en) hochgeladen.',
    resultIndexing: 'Die Indexierung läuft (in der Benachrichtigungsglocke verfolgen).',
    resultSkipped: '{count} Datei(en) übersprungen:',
    skipNonMedia: 'nicht unterstützter Typ',
    skipBadName: 'ungültiger Dateiname',
    skipEmpty: 'leere Datei',
    skipWriteError: 'Schreiben fehlgeschlagen',
    skipConvertFailed: 'Umwandlung fehlgeschlagen',
    skipTooLarge: 'Bild zu groß (Panorama)',
    errorWriteDisabled:
      'Das Schreiben auf der Bibliothek ist deaktiviert. Ein Administrator muss /library beschreibbar einbinden und LIBRARY_WRITABLE aktivieren.',
    errorForbidden: 'Sie sind nicht berechtigt, in diese Bibliothek zu schreiben.',
    error: 'Der Upload ist fehlgeschlagen. Bitte erneut versuchen.',
  },
  trash: {
    deleteSelection: 'Auswahl löschen',
    // Bestätigung „In den Papierkorb“ — betont die UMKEHRBARKEIT (keine Datei wird von der
    // Festplatte gelöscht; endgültiges Löschen nur über die Verwaltung).
    confirmTitle: 'In den Papierkorb (umkehrbar)',
    confirmBody:
      '{count} Datei(en) in den Papierkorb legen? Das ist umkehrbar: Die Dateien bleiben über die Verwaltung wiederherstellbar und KEINE Datei wird von der Festplatte gelöscht. Endgültiges Löschen bleibt später über die Verwaltung möglich.',
    confirmDelete: 'In den Papierkorb',
    cancel: 'Abbrechen',
    deleting: 'Wird gelöscht…',
    error: 'Das Löschen ist fehlgeschlagen. Bitte erneut versuchen.',
    errorForbidden: 'Sie haben keine Berechtigung, diese Dateien zu löschen.',
  },
  bulkRating: {
    rateSelection: 'Auswahl bewerten',
    title: 'Auswahl bewerten',
    intro: 'Eine Bewertung auf die {count} ausgewählten Medien anwenden.',
    selected: 'Gewählte Bewertung: {rating}/5',
    unrated: 'Nicht bewertet (keine Sterne)',
    apply: 'Anwenden',
    applying: 'Wird gespeichert…',
    cancel: 'Abbrechen',
    error: 'Die Bewertung ist fehlgeschlagen. Bitte erneut versuchen.',
    errorForbidden: 'Sie haben keine Berechtigung, diese Dateien zu bewerten.',
  },
  bulkTag: {
    addTag: 'Tag hinzufügen',
    tagAiSelection: 'Auswahl mit KI taggen',
    title: 'Tag hinzufügen',
    intro: 'Ein oder mehrere vorhandene Tags auf die {count} ausgewählten Medien anwenden.',
    searchLabel: 'Tag suchen',
    searchPlaceholder: 'Tags filtern…',
    listLabel: 'Vorhandene Tags',
    loading: 'Tags werden geladen…',
    empty: 'Keine Tags – legen Sie in der Taxonomie welche an.',
    noMatch: 'Kein Tag entspricht der Suche.',
    usageCount: '{count}× verwendet',
    chosenCount: '{count} Tag(s) ausgewählt',
    apply: 'Anwenden',
    applying: 'Wird gespeichert…',
    cancel: 'Abbrechen',
    error: 'Das Hinzufügen von Tags ist fehlgeschlagen. Bitte erneut versuchen.',
    errorForbidden: 'Sie haben keine Berechtigung, diese Dateien zu taggen.',
    loadError: 'Tags konnten nicht geladen werden.',
    // Modus „Entfernen" (Umschalter des Tag-Dialogs).
    modeAdd: 'Hinzufügen',
    modeRemove: 'Entfernen',
    modeGroupLabel: 'Tags hinzufügen oder entfernen',
    titleRemove: 'Tag entfernen',
    introRemove: 'Einen oder mehrere Tags von den {count} ausgewählten Medien entfernen.',
    listLabelRemove: 'Auf der Auswahl vorhandene Tags',
    emptyRemove: 'Auf der Auswahl ist kein Tag vorhanden.',
    presentCount: 'auf {count} Medien',
    removeApply: 'Entfernen',
    removing: 'Wird entfernt…',
    removeError: 'Das Entfernen von Tags ist fehlgeschlagen. Bitte erneut versuchen.',
    // „KI-Vorschläge übernehmen" (Aktionsmenü einer Auswahl).
    acceptAi: 'KI-Vorschläge übernehmen',
    acceptAiTitle: 'KI-Vorschläge übernehmen',
    acceptAiBody:
      'Die von der KI vorgeschlagenen Tags der {count} ausgewählten Foto(s) werden auf „bestätigt" gesetzt. Die Fotos bleiben „Zu prüfen (KI)", bis Sie sie abschließen.',
    acceptAiConfirm: 'Übernehmen',
    acceptAiBusy: 'Wird übernommen…',
    acceptAiError: 'Das Übernehmen der Vorschläge ist fehlgeschlagen. Bitte erneut versuchen.',
    acceptAiForbidden: 'Sie haben keine Berechtigung, diese Tags zu bestätigen.',
  },
  aiSwitch: {
    label: 'KI-Funktionen aktivieren',
    hintEnabled:
      'Die KI-Funktionen sind aktiv: „Auswahl mit KI taggen" wird angeboten und das LLM-Tagging kann gestartet werden.',
    hintDisabled:
      'Die KI-Funktionen sind deaktiviert: „Auswahl mit KI taggen" ist für alle Rollen ausgeblendet und es kann kein KI-Tagging gestartet werden. Der Superadmin kann sie hier wieder aktivieren.',
    forbidden: 'Zugriff verweigert: nur für Superadmins.',
    error: 'Einstellung konnte nicht aktualisiert werden. Bitte erneut versuchen.',
  },
  llm: {
    tab: 'LLM-Konfiguration',
    title: 'LLM-Konfiguration',
    intro:
      'Konfigurieren Sie den Vision-Anbieter, der Tags vorschlägt. Testen Sie die Verbindung, ermitteln Sie verfügbare Modelle, und speichern und aktivieren Sie den Anbieter.',
    providerLabel: 'Anbieter',
    providerLmstudio: 'LM Studio (lokal)',
    providerOllama: 'Ollama (lokal)',
    providerClaude: 'Claude (Anthropic)',
    providerGemini: 'Gemini (Google)',
    providerGrok: 'Grok (xAI)',
    activeSuffix: 'Aktiv',
    baseUrlLabel: 'Basis-URL',
    baseUrlHint:
      'Für LM Studio (lokaler Server) erforderlich. Für Cloud-Anbieter wird ein sinnvoller Standard vorgeschlagen.',
    modelLabel: 'Modell',
    modelPlaceholder: 'Modellname',
    modelHint: 'Name des für diesen Anbieter zu verwendenden Modells.',
    modelHintLmstudio: 'Für diesen Anbieter erforderlich (Name des lokal geladenen Modells).',
    modelDiscoveredLabel: 'Ermittelte Modelle',
    modelClickToChoose: 'zum Auswählen anklicken',
    modelDiscoveredEmpty: 'Dieser Anbieter stellt keine Modelle bereit.',
    loadError:
      'Gespeicherte Anbieter konnten nicht geladen werden. Sie können trotzdem einen einrichten.',
    actionModeLabel: 'KI-Aktionsmodus',
    actionModeAuto: 'Automatisch (empfohlen)',
    actionModeNative: 'Native Werkzeuge',
    actionModeJson: 'JSON im Text',
    actionModeHint:
      'Wie die KI ihre Aktionen auslöst. „Automatisch“ versucht native Werkzeuge und fällt bei Fehlschlag auf JSON zurück. „Native Werkzeuge“ erfordert Function-Calling (fähiges Modell). „JSON im Text“ eignet sich für Modelle ohne Function-Calling (z. B. Gemma) und vermeidet einen aussichtslosen Aufruf.',
    captureFloorLabel: 'Erfassungsschwelle (%)',
    captureFloorHint:
      'Das Modell bewertet alle Tags der Taxonomie; nur Vorschläge mit einem Wert ≥ dieser Schwelle werden behalten (die übrigen verworfen). Standard 10 %. Senken Sie den Wert, um mehr unsichere Tags zu erfassen.',
    promptTemplateLabel: 'Indexierungs-Prompt (Englisch)',
    promptTemplateHint:
      'Vorlage des an das LLM gesendeten Prompts (auf Englisch). Verwenden Sie {{tags}} für die Tag-Liste und {{maxTags}} für die Höchstzahl. Leer lassen für den Standard-Prompt. Der tatsächlich gesendete Prompt erscheint im KI-Aufrufprotokoll.',
    promptTemplateReset: 'Auf Standard-Prompt zurücksetzen',
    apiKeyDetected: 'API-Schlüssel erkannt',
    apiKeyMissing: 'API-Schlüssel fehlt: Setzen Sie die unten angegebene Umgebungsvariable.',
    apiKeyNotRequired: 'Kein Schlüssel erforderlich (lokale Ausführung).',
    apiKeyUnknown: 'Testen Sie die Verbindung, um das Vorhandensein des Schlüssels zu prüfen.',
    testConnection: 'Verbindung testen',
    testConnectionOk: 'Verbindung OK',
    testing: 'Test läuft…',
    testReachable: 'Anbieter erreichbar · {count} Modell(e) ermittelt.',
    testUnreachable: 'Anbieter nicht erreichbar.',
    visionNoModel: 'Geben Sie ein Modell an, um Generierung und Bildverständnis zu testen.',
    visionModelOk: 'Das Modell antwortet (Text).',
    visionModelFail: 'Das Modell antwortet nicht.',
    visionImageOk: 'Das Modell akzeptiert Bilder (Vision).',
    visionImageFail: 'Das Modell lehnt Bilder ab (kein Vision-Modell).',
    saveAndActivate: 'Speichern und aktivieren',
    saving: 'Wird gespeichert…',
    saved: 'Anbieter gespeichert und aktiviert.',
    unsavedChanges: 'Nicht gespeicherte Änderungen',
    errorModelRequired: 'Geben Sie vor dem Speichern ein Modell an.',
    errorBaseUrlRequired: 'Geben Sie vor dem Speichern die Basis-URL an.',
    errorForbidden: 'Zugriff verweigert: nur für Bibliotheksinhaber oder Superadmin.',
    errorGeneric: 'Ein Fehler ist aufgetreten. Bitte erneut versuchen.',
    hintsTitle: 'Anbieterhinweise',
    hintProvider: 'Anbieter',
    hintEnvVar: 'Umgebungsvariable des Schlüssels',
    hintNoEnvVar: 'Keine (lokale Ausführung)',
    hintDoc: 'Konsole / Dokumentation',
    hintDocLink: 'Öffnen',
    noteLmstudio:
      'Lokaler OpenAI-kompatibler Server: kein API-Schlüssel. Starten Sie den Server, geben Sie dann die Basis-URL (Standard http://localhost:1234/v1) und das Modell an.',
    noteOllama:
      'Lokaler Server: kein API-Schlüssel. Starten Sie Ollama, installieren Sie ein Vision-Modell, geben Sie dann die Basis-URL (Standard http://localhost:11434) und das Modell an.',
    noteClaude:
      'Cloud-Anbieter von Anthropic. Erstellen Sie einen Schlüssel in der Konsole, stellen Sie ihn über die Umgebungsvariable XPHOTO_AI_KEY_ANTHROPIC bereit und wählen Sie ein Vision-Modell.',
    noteGemini:
      'Cloud-Anbieter von Google. Erstellen Sie einen Schlüssel in AI Studio, stellen Sie ihn über die Umgebungsvariable XPHOTO_AI_KEY_GEMINI bereit und wählen Sie ein Vision-Modell.',
    noteGrok:
      'Cloud-Anbieter von xAI (OpenAI-kompatibel). Erstellen Sie einen Schlüssel in der Konsole, stellen Sie ihn über die Umgebungsvariable XPHOTO_AI_KEY_XAI bereit und wählen Sie ein Modell.',
  },
  taxonomy: {
    title: 'Taxonomie',
    close: 'Schließen',
    cancel: 'Abbrechen',
    intro:
      'Verwalten Sie das Tag-Vokabular Ihrer Bibliothek: ein einziges Label pro Tag, ohne Kategorie oder Hierarchie. Tags erstellen, umbenennen, löschen oder zusammenführen.',
    createLabel: 'Neuer Tag',
    createPlaceholder: 'Name des neuen Tags…',
    createAction: 'Erstellen',
    searchLabel: 'Tag suchen',
    searchPlaceholder: 'Nach Name filtern…',
    sortLabel: 'Sortieren nach',
    sortName: 'Name',
    sortUsage: 'Verwendung',
    usageCount: 'auf {count} Fotos verwendet',
    usageNone: 'auf keinem Foto verwendet',
    candidate: 'Kandidat',
    hideCandidates: 'Kandidaten ausblenden ({count})',
    loading: 'Vokabular wird geladen…',
    loadError: 'Vokabular konnte nicht geladen werden.',
    empty: 'Noch keine Tags. Erstellen Sie oben einen.',
    noMatch: 'Kein Tag entspricht der Suche.',
    renameAction: 'Umbenennen',
    renameAria: 'Tag {label} umbenennen',
    renameLabel: 'Neuer Tag-Name',
    renameSave: 'Speichern',
    renameCancel: 'Abbrechen',
    descriptionAria: 'Beschreibung des Tags {label} (optional, leitet die KI)',
    descriptionPlaceholder: 'z. B. „Bäume, Blumen, Berge…“',
    descriptionSaving: 'Wird gespeichert…',
    deleteAction: 'Löschen',
    deleteAria: 'Tag {label} löschen',
    deleteTitle: 'Diesen Tag löschen?',
    deleteBody: 'Der Tag „{label}“ wird endgültig aus dem Vokabular entfernt.',
    deleteUsedWarning:
      'Dieser Tag wird auf {count} Fotos verwendet: Er wird von ihnen entfernt. Diese Aktion ist unwiderruflich.',
    deleteConfirm: 'Löschen',
    deleting: 'Wird gelöscht…',
    selectForMerge: 'Tag {label} für die Zusammenführung auswählen',
    mergeSelected: '{count} Tags ausgewählt',
    mergeTargetLabel: 'Behalten',
    mergeTargetPlaceholder: 'Zu behaltenden Tag wählen…',
    mergeAction: 'Zusammenführen',
    mergeClear: 'Auswahl aufheben',
    mergeHint: 'Wählen Sie mindestens zwei Tags zum Zusammenführen aus.',
    mergeTitle: 'Tags zusammenführen?',
    mergeBody:
      'Die {count} Tags ({sources}) werden in „{target}“ zusammengeführt: Ihre Fotos werden dorthin übertragen und diese Tags anschließend gelöscht.',
    mergeNote:
      'Der behaltene Tag trägt danach alle betroffenen Fotos. Diese Aktion ist unwiderruflich.',
    mergeConfirm: 'Zusammenführen',
    merging: 'Wird zusammengeführt…',
    errorDuplicate: 'Dieser Tag existiert bereits.',
    errorGeneric: 'Der Vorgang ist fehlgeschlagen. Bitte erneut versuchen.',
  },
  tagging: {
    title: 'Tags prüfen / bestätigen',
    panelTitle: 'Tags des Fotos',
    listLabel: 'Tags der Taxonomie',
    validateAndNext: 'Bestätigen und weiter',
    validateAndFinish: 'Bestätigen und abschließen',
    validating: 'Wird bestätigt…',
    confidence: 'KI · {pct} %',
    readonly: 'Nur-Lese-Zugriff: Tags können nicht geändert werden.',
    error: 'Die Bestätigung ist fehlgeschlagen. Bitte erneut versuchen.',
    loading: 'Tags werden geladen…',
    errorLoad: 'Tags konnten nicht geladen werden.',
    retry: 'Erneut versuchen',
    empty: 'Keine Tags in der Taxonomie. Erstellen Sie welche unter „Tags verwalten“.',
  },
  aiTrace: {
    title: 'KI-Aufrufprotokoll',
    tab: 'KI-Aufrufprotokoll',
    intro:
      'Jeder Aufruf des KI-Taggings an das Vision-Modell wird hier protokolliert: der gesendete Prompt (Ihre Tags und ihre Beschreibungen, mit dem Verbot, neue zu erstellen) und die Rohantwort des Modells. Nützlich, um zu prüfen, was gesendet und empfangen wird.',
    total: '{count} protokollierte Aufrufe',
    model: 'Modell',
    promptLabel: 'Gesendeter Prompt',
    responseLabel: 'Antwort des Modells',
    noResponse: '(keine Antwort)',
    reachable: 'Geantwortet',
    unreachable: 'Nicht erreichbar',
    summary: '{linked} Tags verknüpft · {newLabels} außerhalb der Taxonomie ignoriert',
    errorLabel: 'Fehler',
    prevPage: 'Zurück',
    nextPage: 'Weiter',
    pageStatus: '{from}–{to} von {total}',
    loading: 'Protokoll wird geladen…',
    errorLoad: 'Protokoll konnte nicht geladen werden.',
    retry: 'Erneut versuchen',
    empty: 'Keine Aufrufe protokolliert',
    emptyHint:
      'Wählen Sie Fotos aus und dann „Aktionen…“ → „Auswahl mit KI taggen“, um Aufrufe zu erzeugen.',
  },
  advancedSearch: {
    open: 'Suche',
    title: 'Suche',
    intro: 'Suchen Sie nach Dateiname, Bewertung und Tags. Die Kriterien werden kombiniert.',
    filenameSection: 'Dateiname',
    filenamePlaceholder: 'Nach Dateiname suchen…',
    ratingSection: 'Mindestbewertung',
    ratingAny: 'Alle Bewertungen',
    ratingAtLeast: 'Mindestens {rating}/5',
    tagsSection: 'Tags',
    tagModeLabel: 'Tag-Übereinstimmung',
    tagModeAny: 'Mindestens einer',
    tagModeAll: 'Alle',
    apply: 'Anwenden',
    reset: 'Zurücksetzen',
    cancel: 'Abbrechen',
    chipsLabel: 'Aktive Suchfilter',
    chipFilename: 'Name: {q}',
    chipRating: 'Bewertung ≥ {rating}★',
    chipTagsAny: 'Tags (mindestens einer): {count}',
    chipTagsAll: 'Tags (alle): {count}',
    removeFilename: 'Namensfilter entfernen',
    removeRating: 'Bewertungsfilter entfernen',
    removeTags: 'Tag-Filter entfernen',
  },
  savedFilters: {
    open: 'Meine Filter',
    none: 'Keine gespeicherten Filter',
    loading: 'Wird geladen…',
    loadError: 'Ihre Filter konnten nicht geladen werden.',
    applyLabel: 'Filter {name} anwenden',
    saveCurrent: 'Aktuellen Filter speichern…',
    editExpr: 'Ausdruck bearbeiten…',
    manage: 'Meine Filter verwalten…',
    saveTitle: 'Filter speichern',
    nameLabel: 'Filtername',
    namePlaceholder: 'z. B. Urlaub 4★ und mehr',
    exprPreview: 'Gespeicherter Ausdruck',
    iconLabel: 'Symbol',
    iconNone: 'Kein Symbol',
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    cancel: 'Abbrechen',
    errorNameTaken: 'Dieser Name ist bereits vergeben.',
    errorStale:
      'Dieser Filter wurde zwischenzeitlich anderswo geändert. Vor dem Speichern neu laden.',
    errorEmptyExpr: 'Stellen Sie zuerst einen Filter zusammen.',
    errorSave: 'Filter konnte nicht gespeichert werden. Erneut versuchen.',
    manageTitle: 'Meine Filter verwalten',
    manageEmpty: 'Sie haben keine gespeicherten Filter.',
    renameLabel: '{name} umbenennen',
    changeIcon: 'Symbol von {name} ändern',
    delete: 'Löschen',
    deleteAria: 'Filter {name} löschen',
    moveUp: '{name} nach oben',
    moveDown: '{name} nach unten',
    deleteConfirmTitle: 'Filter löschen',
    deleteConfirmBody: 'Filter „{name}" löschen? Dieser Vorgang ist endgültig.',
    deleteConfirm: 'Löschen',
    deleting: 'Wird gelöscht…',
    errorUpdate: 'Filter konnte nicht aktualisiert werden. Erneut versuchen.',
    errorReorder: 'Filter konnten nicht umsortiert werden. Erneut versuchen.',
    errorDelete: 'Filter konnte nicht gelöscht werden. Erneut versuchen.',
    done: 'Schließen',
    iconName: {
      funnel: 'Trichter',
      star: 'Stern',
      camera: 'Kamera',
      videoCamera: 'Videokamera',
      sparkles: 'Funken',
      tag: 'Etikett',
      sun: 'Sonne',
      heart: 'Herz',
      bookmark: 'Lesezeichen',
      photo: 'Foto',
    },
  },
  filterExpr: {
    editTitle: 'Erweiterter Ausdruck',
    intro: 'Stellen Sie einen Filter mit UND, ODER, AUSSER und Klammern zusammen.',
    fieldLabel: 'Filterausdruck',
    placeholder: 'z. B. note>=4 ODER (tag:Strand UND tag:Sommer)',
    echoLabel: 'Lesart:',
    empty: 'Geben Sie einen Ausdruck für die Vorschau ein.',
    paletteLabel: 'Tag einfügen',
    connector: 'Verknüpfen mit',
    connectorOr: 'ODER',
    connectorAnd: 'UND',
    connectorExcept: 'AUSSER',
    paletteSearchLabel: 'Tag suchen',
    paletteSearchPlaceholder: 'Tag suchen…',
    legendTitle: 'Vokabular',
    legend: 'type:  note>=  tag:  ordner:  name:  status:  ·  UND  ODER  AUSSER  ( )',
    reset: 'Zurücksetzen',
    saveAs: 'Speichern unter…',
    apply: 'Anwenden',
    cancel: 'Abbrechen',
    and: 'und',
    or: 'oder',
    except: 'außer {x}',
    leaf: {
      tag: 'markiert mit „{label}"',
      type: 'vom Typ {type}',
      ratingGte: 'mit {value}★ oder mehr bewertet',
      ratingLte: 'mit {value}★ oder weniger bewertet',
      ratingEq: 'mit genau {value}★ bewertet',
      folder: 'im Ordner „{folder}"',
      folderRoot: 'im Stammverzeichnis',
      filename: 'mit Namen, der „{name}" enthält',
      status: 'mit Status {status}',
    },
    typeName: {
      image: 'Bild',
      animatedImage: 'animiertes Bild',
      video: 'Video',
      videoWithSound: 'Video mit Ton',
    },
    statusName: {
      tagged: 'markiert',
      untagged: 'nicht markiert',
      aiPending: 'zu prüfen (KI)',
    },
    error: {
      empty: 'Geben Sie einen Ausdruck ein.',
      unexpectedToken: 'Unerwartetes Zeichen an Position {position}.',
      unexpectedEof: 'Unvollständiger Ausdruck: ein Kriterium wird erwartet.',
      unclosedParen: 'Nicht geschlossene öffnende Klammer.',
      unclosedQuote: 'Nicht geschlossenes Anführungszeichen.',
      invalidRating: 'Ungültige Bewertung (ganze Zahl von 0 bis 5).',
      unknownType: 'Unbekannter Typ (image, animée, vidéo, vidéo-son).',
      unknownStatus: 'Unbekannter Status (taguée, non-taguée, à-valider).',
      unknownField: 'Unbekanntes Feldpräfix (type, note, tag, dossier, nom, statut).',
      emptyValue: 'Fehlender Wert nach dem Präfix.',
    },
  },
  exprChips: {
    label: 'Aktiver erweiterter Filter',
    advanced: 'Erweiterter Ausdruck',
    remove: 'Erweiterten Filter entfernen',
  },
  a11y: {
    skipToContent: 'Zum Hauptinhalt springen',
    closeMenu: 'Menü schließen',
  },
};
